/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateSpeedTest = /* GraphQL */ `
  subscription OnCreateSpeedTest(
    $filter: ModelSubscriptionSpeedTestFilterInput
  ) {
    onCreateSpeedTest(filter: $filter) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const onUpdateSpeedTest = /* GraphQL */ `
  subscription OnUpdateSpeedTest(
    $filter: ModelSubscriptionSpeedTestFilterInput
  ) {
    onUpdateSpeedTest(filter: $filter) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const onDeleteSpeedTest = /* GraphQL */ `
  subscription OnDeleteSpeedTest(
    $filter: ModelSubscriptionSpeedTestFilterInput
  ) {
    onDeleteSpeedTest(filter: $filter) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const onCreateGlobalSpeedTest = /* GraphQL */ `
  subscription OnCreateGlobalSpeedTest(
    $filter: ModelSubscriptionGlobalSpeedTestFilterInput
  ) {
    onCreateGlobalSpeedTest(filter: $filter) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const onUpdateGlobalSpeedTest = /* GraphQL */ `
  subscription OnUpdateGlobalSpeedTest(
    $filter: ModelSubscriptionGlobalSpeedTestFilterInput
  ) {
    onUpdateGlobalSpeedTest(filter: $filter) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const onDeleteGlobalSpeedTest = /* GraphQL */ `
  subscription OnDeleteGlobalSpeedTest(
    $filter: ModelSubscriptionGlobalSpeedTestFilterInput
  ) {
    onDeleteGlobalSpeedTest(filter: $filter) {
      id
      createdAt
      updatedAt
      someData
      indexOne
      indexTwo
      indexThree
    }
  }
`;
export const onCreateQualityReportTemplates = /* GraphQL */ `
  subscription OnCreateQualityReportTemplates(
    $filter: ModelSubscriptionQualityReportTemplatesFilterInput
  ) {
    onCreateQualityReportTemplates(filter: $filter) {
      id
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      categories
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateQualityReportTemplates = /* GraphQL */ `
  subscription OnUpdateQualityReportTemplates(
    $filter: ModelSubscriptionQualityReportTemplatesFilterInput
  ) {
    onUpdateQualityReportTemplates(filter: $filter) {
      id
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      categories
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteQualityReportTemplates = /* GraphQL */ `
  subscription OnDeleteQualityReportTemplates(
    $filter: ModelSubscriptionQualityReportTemplatesFilterInput
  ) {
    onDeleteQualityReportTemplates(filter: $filter) {
      id
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      categories
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCompanies = /* GraphQL */ `
  subscription OnCreateCompanies(
    $filter: ModelSubscriptionCompaniesFilterInput
    $id: String
    $contactPersonUserId: String
    $countryCode: String
  ) {
    onCreateCompanies(
      filter: $filter
      id: $id
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
    ) {
      id
      addresses {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      companyContactPersons {
        items {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        nextToken
      }
      visits {
        items {
          id
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          visitors
          address {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          participants
          hygiene
          environment
          purpose
          visitnumber
          additionalInformation
          countryCode
          date
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      number
      externalNumber
      name
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      users {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        nextToken
      }
      productRequests {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      baseType
      exportCompanyId
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      companiesProductCategories {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          categoryId
          countryCode
          finalStage
          isAccepted
          createdAt
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onUpdateCompanies = /* GraphQL */ `
  subscription OnUpdateCompanies(
    $filter: ModelSubscriptionCompaniesFilterInput
    $id: String
    $contactPersonUserId: String
    $countryCode: String
  ) {
    onUpdateCompanies(
      filter: $filter
      id: $id
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
    ) {
      id
      addresses {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      companyContactPersons {
        items {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        nextToken
      }
      visits {
        items {
          id
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          visitors
          address {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          participants
          hygiene
          environment
          purpose
          visitnumber
          additionalInformation
          countryCode
          date
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      number
      externalNumber
      name
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      users {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        nextToken
      }
      productRequests {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      baseType
      exportCompanyId
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      companiesProductCategories {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          categoryId
          countryCode
          finalStage
          isAccepted
          createdAt
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onDeleteCompanies = /* GraphQL */ `
  subscription OnDeleteCompanies(
    $filter: ModelSubscriptionCompaniesFilterInput
    $id: String
    $contactPersonUserId: String
    $countryCode: String
  ) {
    onDeleteCompanies(
      filter: $filter
      id: $id
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
    ) {
      id
      addresses {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      companyContactPersons {
        items {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        nextToken
      }
      visits {
        items {
          id
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          visitors
          address {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          participants
          hygiene
          environment
          purpose
          visitnumber
          additionalInformation
          countryCode
          date
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      number
      externalNumber
      name
      nameSearch
      type
      googleId
      size
      itemsID
      standardPaymentConditions
      paymentConditions
      standardDeliveryConditions
      standardVat
      users {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        nextToken
      }
      productRequests {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      countryCode
      closestPortUNCode
      websiteUrl
      vatNumber
      baseType
      exportCompanyId
      initialSetup
      productionCountryCode
      preferredCurrency
      communicationLanguage
      foundingDate
      companiesProductCategories {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          categoryId
          countryCode
          finalStage
          isAccepted
          createdAt
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onCreateCompaniesContactPersons = /* GraphQL */ `
  subscription OnCreateCompaniesContactPersons(
    $filter: ModelSubscriptionCompaniesContactPersonsFilterInput
    $companyID: String
    $contactPersonUserId: String
    $countryCode: String
  ) {
    onCreateCompaniesContactPersons(
      filter: $filter
      companyID: $companyID
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
    ) {
      id
      companyID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      userID
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCompaniesContactPersons = /* GraphQL */ `
  subscription OnUpdateCompaniesContactPersons(
    $filter: ModelSubscriptionCompaniesContactPersonsFilterInput
    $companyID: String
    $contactPersonUserId: String
    $countryCode: String
  ) {
    onUpdateCompaniesContactPersons(
      filter: $filter
      companyID: $companyID
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
    ) {
      id
      companyID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      userID
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCompaniesContactPersons = /* GraphQL */ `
  subscription OnDeleteCompaniesContactPersons(
    $filter: ModelSubscriptionCompaniesContactPersonsFilterInput
    $companyID: String
    $contactPersonUserId: String
    $countryCode: String
  ) {
    onDeleteCompaniesContactPersons(
      filter: $filter
      companyID: $companyID
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
    ) {
      id
      companyID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      userID
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      email
      firstName
      lastName
      mobil
      phone
      position
      countryCode
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCompaniesProductCategories = /* GraphQL */ `
  subscription OnCreateCompaniesProductCategories(
    $filter: ModelSubscriptionCompaniesProductCategoriesFilterInput
    $countryCode: String
    $companyId: String
  ) {
    onCreateCompaniesProductCategories(
      filter: $filter
      countryCode: $countryCode
      companyId: $companyId
    ) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCompaniesProductCategories = /* GraphQL */ `
  subscription OnUpdateCompaniesProductCategories(
    $filter: ModelSubscriptionCompaniesProductCategoriesFilterInput
    $countryCode: String
    $companyId: String
  ) {
    onUpdateCompaniesProductCategories(
      filter: $filter
      countryCode: $countryCode
      companyId: $companyId
    ) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCompaniesProductCategories = /* GraphQL */ `
  subscription OnDeleteCompaniesProductCategories(
    $filter: ModelSubscriptionCompaniesProductCategoriesFilterInput
    $countryCode: String
    $companyId: String
  ) {
    onDeleteCompaniesProductCategories(
      filter: $filter
      countryCode: $countryCode
      companyId: $companyId
    ) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      categoryId
      countryCode
      finalStage
      isAccepted
      createdAt
      updatedAt
    }
  }
`;
export const onCreateVisits = /* GraphQL */ `
  subscription OnCreateVisits(
    $filter: ModelSubscriptionVisitsFilterInput
    $countryCode: String
  ) {
    onCreateVisits(filter: $filter, countryCode: $countryCode) {
      id
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      visitors
      address {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      participants
      hygiene
      environment
      purpose
      visitnumber
      additionalInformation
      countryCode
      date
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateVisits = /* GraphQL */ `
  subscription OnUpdateVisits(
    $filter: ModelSubscriptionVisitsFilterInput
    $countryCode: String
  ) {
    onUpdateVisits(filter: $filter, countryCode: $countryCode) {
      id
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      visitors
      address {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      participants
      hygiene
      environment
      purpose
      visitnumber
      additionalInformation
      countryCode
      date
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteVisits = /* GraphQL */ `
  subscription OnDeleteVisits(
    $filter: ModelSubscriptionVisitsFilterInput
    $countryCode: String
  ) {
    onDeleteVisits(filter: $filter, countryCode: $countryCode) {
      id
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      visitors
      address {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      participants
      hygiene
      environment
      purpose
      visitnumber
      additionalInformation
      countryCode
      date
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCustoms = /* GraphQL */ `
  subscription OnCreateCustoms($filter: ModelSubscriptionCustomsFilterInput) {
    onCreateCustoms(filter: $filter) {
      id
      currentCustomsStatus
      createdAt
      containerFreightCost {
        currency
        value
      }
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      positions {
        hsCode
        itemDeclaration
        invoiceValue {
          currency
          value
        }
        tax {
          currency
          value
        }
        customsValue {
          currency
          value
        }
        iktValue {
          currency
          value
        }
        quantity
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
      }
      customsLocation
      weightNet {
        value
        unit
      }
      weightGross {
        value
        unit
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateCustoms = /* GraphQL */ `
  subscription OnUpdateCustoms($filter: ModelSubscriptionCustomsFilterInput) {
    onUpdateCustoms(filter: $filter) {
      id
      currentCustomsStatus
      createdAt
      containerFreightCost {
        currency
        value
      }
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      positions {
        hsCode
        itemDeclaration
        invoiceValue {
          currency
          value
        }
        tax {
          currency
          value
        }
        customsValue {
          currency
          value
        }
        iktValue {
          currency
          value
        }
        quantity
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
      }
      customsLocation
      weightNet {
        value
        unit
      }
      weightGross {
        value
        unit
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteCustoms = /* GraphQL */ `
  subscription OnDeleteCustoms($filter: ModelSubscriptionCustomsFilterInput) {
    onDeleteCustoms(filter: $filter) {
      id
      currentCustomsStatus
      createdAt
      containerFreightCost {
        currency
        value
      }
      originCountry
      releaseDate
      positionNumber
      mrnNumber
      sentMrnNumber
      positions {
        hsCode
        itemDeclaration
        invoiceValue {
          currency
          value
        }
        tax {
          currency
          value
        }
        customsValue {
          currency
          value
        }
        iktValue {
          currency
          value
        }
        quantity
        weightNet {
          value
          unit
        }
        weightGross {
          value
          unit
        }
      }
      customsLocation
      weightNet {
        value
        unit
      }
      weightGross {
        value
        unit
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateUsers = /* GraphQL */ `
  subscription OnCreateUsers(
    $filter: ModelSubscriptionUsersFilterInput
    $companyId: String
    $countryCode: String
    $id: String
    $contactPersonUserId: String
  ) {
    onCreateUsers(
      filter: $filter
      companyId: $companyId
      countryCode: $countryCode
      id: $id
      contactPersonUserId: $contactPersonUserId
    ) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      notifications
      productTourStatus
      roleId
      role {
        id
        roleName
        type
        cognitoUserGroup
        permissions
        createdAt
        updatedAt
      }
      settings
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const onUpdateUsers = /* GraphQL */ `
  subscription OnUpdateUsers(
    $filter: ModelSubscriptionUsersFilterInput
    $companyId: String
    $countryCode: String
    $id: String
    $contactPersonUserId: String
  ) {
    onUpdateUsers(
      filter: $filter
      companyId: $companyId
      countryCode: $countryCode
      id: $id
      contactPersonUserId: $contactPersonUserId
    ) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      notifications
      productTourStatus
      roleId
      role {
        id
        roleName
        type
        cognitoUserGroup
        permissions
        createdAt
        updatedAt
      }
      settings
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const onDeleteUsers = /* GraphQL */ `
  subscription OnDeleteUsers(
    $filter: ModelSubscriptionUsersFilterInput
    $companyId: String
    $countryCode: String
    $id: String
    $contactPersonUserId: String
  ) {
    onDeleteUsers(
      filter: $filter
      companyId: $companyId
      countryCode: $countryCode
      id: $id
      contactPersonUserId: $contactPersonUserId
    ) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      companyContactPersonUserId
      country
      contactPersonUserId
      email
      imageUrl
      lastLogin
      firstName
      lastName
      language
      mobil
      phone
      position
      notifications
      productTourStatus
      roleId
      role {
        id
        roleName
        type
        cognitoUserGroup
        permissions
        createdAt
        updatedAt
      }
      settings
      createdAt
      updatedAt
      countryCode
    }
  }
`;
export const onCreateContactPersons = /* GraphQL */ `
  subscription OnCreateContactPersons(
    $filter: ModelSubscriptionContactPersonsFilterInput
  ) {
    onCreateContactPersons(filter: $filter) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      hubspotId
      countries
      type
      funnel
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContactPersons = /* GraphQL */ `
  subscription OnUpdateContactPersons(
    $filter: ModelSubscriptionContactPersonsFilterInput
  ) {
    onUpdateContactPersons(filter: $filter) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      hubspotId
      countries
      type
      funnel
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContactPersons = /* GraphQL */ `
  subscription OnDeleteContactPersons(
    $filter: ModelSubscriptionContactPersonsFilterInput
  ) {
    onDeleteContactPersons(filter: $filter) {
      id
      email
      imageUrl
      firstName
      lastName
      mobil
      phone
      position
      hubspotId
      countries
      type
      funnel
      createdAt
      updatedAt
    }
  }
`;
export const onCreateUserRoles = /* GraphQL */ `
  subscription OnCreateUserRoles(
    $filter: ModelSubscriptionUserRolesFilterInput
    $id: String
  ) {
    onCreateUserRoles(filter: $filter, id: $id) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateUserRoles = /* GraphQL */ `
  subscription OnUpdateUserRoles(
    $filter: ModelSubscriptionUserRolesFilterInput
    $id: String
  ) {
    onUpdateUserRoles(filter: $filter, id: $id) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteUserRoles = /* GraphQL */ `
  subscription OnDeleteUserRoles(
    $filter: ModelSubscriptionUserRolesFilterInput
    $id: String
  ) {
    onDeleteUserRoles(filter: $filter, id: $id) {
      id
      roleName
      type
      cognitoUserGroup
      permissions
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInvitations = /* GraphQL */ `
  subscription OnCreateInvitations(
    $filter: ModelSubscriptionInvitationsFilterInput
    $companyId: String
  ) {
    onCreateInvitations(filter: $filter, companyId: $companyId) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const onUpdateInvitations = /* GraphQL */ `
  subscription OnUpdateInvitations(
    $filter: ModelSubscriptionInvitationsFilterInput
    $companyId: String
  ) {
    onUpdateInvitations(filter: $filter, companyId: $companyId) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const onDeleteInvitations = /* GraphQL */ `
  subscription OnDeleteInvitations(
    $filter: ModelSubscriptionInvitationsFilterInput
    $companyId: String
  ) {
    onDeleteInvitations(filter: $filter, companyId: $companyId) {
      id
      companyId
      createdAt
      email
      invitedByUserId
      invitedByUserName
      language
      roleId
      countryCode
      reminderStatus
      ttl
      updatedAt
    }
  }
`;
export const onCreateNotifications = /* GraphQL */ `
  subscription OnCreateNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $userId: String
  ) {
    onCreateNotifications(filter: $filter, userId: $userId) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      ttl
    }
  }
`;
export const onUpdateNotifications = /* GraphQL */ `
  subscription OnUpdateNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $userId: String
  ) {
    onUpdateNotifications(filter: $filter, userId: $userId) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      ttl
    }
  }
`;
export const onDeleteNotifications = /* GraphQL */ `
  subscription OnDeleteNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $userId: String
  ) {
    onDeleteNotifications(filter: $filter, userId: $userId) {
      createdAt
      updatedAt
      id
      userEmail
      title
      message
      userRead
      reference
      userId
      icon
      iconBackgroundColor
      type
      emailNotification
      ttl
    }
  }
`;
export const onCreateOrders = /* GraphQL */ `
  subscription OnCreateOrders(
    $filter: ModelSubscriptionOrdersFilterInput
    $companyId: String
    $contactPersonUserId: String
  ) {
    onCreateOrders(
      filter: $filter
      companyId: $companyId
      contactPersonUserId: $contactPersonUserId
    ) {
      id
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdAt
      orderDate
      cancelled
      companyId
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      deliveryDate {
        actual
        allItemsSet
        planned
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      items {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      orderNumber
      orderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdByUserId
      purchaseOrder
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateOrders = /* GraphQL */ `
  subscription OnUpdateOrders(
    $filter: ModelSubscriptionOrdersFilterInput
    $companyId: String
    $contactPersonUserId: String
  ) {
    onUpdateOrders(
      filter: $filter
      companyId: $companyId
      contactPersonUserId: $contactPersonUserId
    ) {
      id
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdAt
      orderDate
      cancelled
      companyId
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      deliveryDate {
        actual
        allItemsSet
        planned
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      items {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      orderNumber
      orderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdByUserId
      purchaseOrder
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteOrders = /* GraphQL */ `
  subscription OnDeleteOrders(
    $filter: ModelSubscriptionOrdersFilterInput
    $companyId: String
    $contactPersonUserId: String
  ) {
    onDeleteOrders(
      filter: $filter
      companyId: $companyId
      contactPersonUserId: $contactPersonUserId
    ) {
      id
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdAt
      orderDate
      cancelled
      companyId
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      currentOrderStatus
      customerReference
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      deliveryDate {
        actual
        allItemsSet
        planned
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      items {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      orderNumber
      orderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      sapCompanyName
      sapConfirmedDeliveryDate
      predictiveDeliveryDate
      sapCustomerNumber
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      createdByUserId
      purchaseOrder
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateOrderItems = /* GraphQL */ `
  subscription OnCreateOrderItems(
    $filter: ModelSubscriptionOrderItemsFilterInput
    $companyId: String
  ) {
    onCreateOrderItems(filter: $filter, companyId: $companyId) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      deliveries {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      shipments {
        items {
          id
          companyId
          shipmentsID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      ordersID
      order {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      purchaseOrderItemsID
      manualPurchaseOrderItemsID
      purchaseOrderItemsM {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onUpdateOrderItems = /* GraphQL */ `
  subscription OnUpdateOrderItems(
    $filter: ModelSubscriptionOrderItemsFilterInput
    $companyId: String
  ) {
    onUpdateOrderItems(filter: $filter, companyId: $companyId) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      deliveries {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      shipments {
        items {
          id
          companyId
          shipmentsID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      ordersID
      order {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      purchaseOrderItemsID
      manualPurchaseOrderItemsID
      purchaseOrderItemsM {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onDeleteOrderItems = /* GraphQL */ `
  subscription OnDeleteOrderItems(
    $filter: ModelSubscriptionOrderItemsFilterInput
    $companyId: String
  ) {
    onDeleteOrderItems(filter: $filter, companyId: $companyId) {
      id
      companyId
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      deliveryDate
      orderDate
      currentOrderStatus
      customerItemNumber
      customerReference
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      deliveries {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      shipments {
        items {
          id
          companyId
          shipmentsID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      ordersID
      order {
        id
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdAt
        orderDate
        cancelled
        companyId
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        currentOrderStatus
        customerReference
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        deliveryDate {
          actual
          allItemsSet
          planned
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        items {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        orderNumber
        orderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        sapCompanyName
        sapConfirmedDeliveryDate
        predictiveDeliveryDate
        sapCustomerNumber
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        createdByUserId
        purchaseOrder
        shipments {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        baseType
        updatedAt
      }
      purchaseOrderItemsID
      manualPurchaseOrderItemsID
      purchaseOrderItemsM {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onCreatePurchaseOrders = /* GraphQL */ `
  subscription OnCreatePurchaseOrders(
    $filter: ModelSubscriptionPurchaseOrdersFilterInput
    $country: String
  ) {
    onCreatePurchaseOrders(filter: $filter, country: $country) {
      id
      createdAt
      cancelled
      country
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      currentPurchaseOrderStatus
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      finishedDate
      manufacturerContactPersonUserId
      manufacturerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      manufacturerAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      title
      purchaseOrderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      salesConfirmationNumber
      items {
        items {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const onUpdatePurchaseOrders = /* GraphQL */ `
  subscription OnUpdatePurchaseOrders(
    $filter: ModelSubscriptionPurchaseOrdersFilterInput
    $country: String
  ) {
    onUpdatePurchaseOrders(filter: $filter, country: $country) {
      id
      createdAt
      cancelled
      country
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      currentPurchaseOrderStatus
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      finishedDate
      manufacturerContactPersonUserId
      manufacturerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      manufacturerAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      title
      purchaseOrderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      salesConfirmationNumber
      items {
        items {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const onDeletePurchaseOrders = /* GraphQL */ `
  subscription OnDeletePurchaseOrders(
    $filter: ModelSubscriptionPurchaseOrdersFilterInput
    $country: String
  ) {
    onDeletePurchaseOrders(filter: $filter, country: $country) {
      id
      createdAt
      cancelled
      country
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      currentPurchaseOrderStatus
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      finishedDate
      manufacturerContactPersonUserId
      manufacturerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      manufacturerAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      purchaseOrderNumber
      sapReference
      sapSupplierNumber
      sapSupplierCompanyName
      confirmed
      openingRemark
      closingRemark
      plannedTransportationType
      discount {
        currency
        value
      }
      freightCost {
        currency
        value
      }
      paymentConditions
      title
      purchaseOrderStatusProcess {
        duration
        endAt
        name
        position
        startAt
      }
      salesConfirmationNumber
      items {
        items {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      googleId
      orderIdsGoogle
      baseType
      updatedAt
    }
  }
`;
export const onCreatePurchaseOrderItems = /* GraphQL */ `
  subscription OnCreatePurchaseOrderItems(
    $filter: ModelSubscriptionPurchaseOrderItemsFilterInput
    $country: String
  ) {
    onCreatePurchaseOrderItems(filter: $filter, country: $country) {
      id
      purchaseOrdersID
      purchaseOrder {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      orderNumberReference
      sapOrderLineNumberReference
      orderItems {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      orderItemsM {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          shipmentsID
          purchaseOrderItemsID
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity
          comment
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onUpdatePurchaseOrderItems = /* GraphQL */ `
  subscription OnUpdatePurchaseOrderItems(
    $filter: ModelSubscriptionPurchaseOrderItemsFilterInput
    $country: String
  ) {
    onUpdatePurchaseOrderItems(filter: $filter, country: $country) {
      id
      purchaseOrdersID
      purchaseOrder {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      orderNumberReference
      sapOrderLineNumberReference
      orderItems {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      orderItemsM {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          shipmentsID
          purchaseOrderItemsID
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity
          comment
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onDeletePurchaseOrderItems = /* GraphQL */ `
  subscription OnDeletePurchaseOrderItems(
    $filter: ModelSubscriptionPurchaseOrderItemsFilterInput
    $country: String
  ) {
    onDeletePurchaseOrderItems(filter: $filter, country: $country) {
      id
      purchaseOrdersID
      purchaseOrder {
        id
        createdAt
        cancelled
        country
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        currentPurchaseOrderStatus
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        finishedDate
        manufacturerContactPersonUserId
        manufacturerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        manufacturerAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        purchaseOrderNumber
        sapReference
        sapSupplierNumber
        sapSupplierCompanyName
        confirmed
        openingRemark
        closingRemark
        plannedTransportationType
        discount {
          currency
          value
        }
        freightCost {
          currency
          value
        }
        paymentConditions
        title
        purchaseOrderStatusProcess {
          duration
          endAt
          name
          position
          startAt
        }
        salesConfirmationNumber
        items {
          items {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        googleId
        orderIdsGoogle
        baseType
        updatedAt
      }
      createdAt
      country
      companyID
      currentPurchaseOrderStatus
      finishedDate
      manufacturerItemNumber
      number
      quantity
      title
      price {
        currency
        value
      }
      ean
      weight {
        value
        unit
      }
      length {
        value
        unit
      }
      width {
        value
        unit
      }
      height {
        value
        unit
      }
      hsCode
      volume {
        value
        unit
      }
      sapLineNumber
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      orderNumberReference
      sapOrderLineNumberReference
      orderItems {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      orderItemsM {
        items {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          deliveryDate
          orderDate
          currentOrderStatus
          customerItemNumber
          customerReference
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          deliveries {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          shipments {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          ordersID
          order {
            id
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdAt
            orderDate
            cancelled
            companyId
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            currentOrderStatus
            customerReference
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            deliveryDate {
              actual
              allItemsSet
              planned
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            items {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            orderNumber
            orderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            sapCompanyName
            sapConfirmedDeliveryDate
            predictiveDeliveryDate
            sapCustomerNumber
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            createdByUserId
            purchaseOrder
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            baseType
            updatedAt
          }
          purchaseOrderItemsID
          manualPurchaseOrderItemsID
          purchaseOrderItemsM {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      shipments {
        items {
          id
          shipmentsID
          purchaseOrderItemsID
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity
          comment
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onCreateDeliveriesOrderItems = /* GraphQL */ `
  subscription OnCreateDeliveriesOrderItems(
    $filter: ModelSubscriptionDeliveriesOrderItemsFilterInput
    $companyId: String
    $ownerIds: String
  ) {
    onCreateDeliveriesOrderItems(
      filter: $filter
      companyId: $companyId
      ownerIds: $ownerIds
    ) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      comment
      deliveries {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const onUpdateDeliveriesOrderItems = /* GraphQL */ `
  subscription OnUpdateDeliveriesOrderItems(
    $filter: ModelSubscriptionDeliveriesOrderItemsFilterInput
    $companyId: String
    $ownerIds: String
  ) {
    onUpdateDeliveriesOrderItems(
      filter: $filter
      companyId: $companyId
      ownerIds: $ownerIds
    ) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      comment
      deliveries {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const onDeleteDeliveriesOrderItems = /* GraphQL */ `
  subscription OnDeleteDeliveriesOrderItems(
    $filter: ModelSubscriptionDeliveriesOrderItemsFilterInput
    $companyId: String
    $ownerIds: String
  ) {
    onDeleteDeliveriesOrderItems(
      filter: $filter
      companyId: $companyId
      ownerIds: $ownerIds
    ) {
      id
      companyId
      deliveriesID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      comment
      deliveries {
        id
        createdAt
        size
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        trackingInformation
        positionNumber
        shipmentsID
        shipment {
          id
          size
          originCountry
          createdAt
          customsMrnNumber
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          freeText
          manualTracking
          trackingInformation
          positionNumber
          purchaseOrderItems {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          orderItems {
            items {
              id
              companyId
              shipmentsID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          deliveriesID
          delivery {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentShipmentStatus
          type
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          position
          googleId
          telexReleaseStatus
          customsClearanceStatus
          trackingCode
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          customsID
          customs {
            id
            currentCustomsStatus
            createdAt
            containerFreightCost {
              currency
              value
            }
            originCountry
            releaseDate
            positionNumber
            mrnNumber
            sentMrnNumber
            positions {
              hsCode
              itemDeclaration
              invoiceValue {
                currency
                value
              }
              tax {
                currency
                value
              }
              customsValue {
                currency
                value
              }
              iktValue {
                currency
                value
              }
              quantity
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
            }
            customsLocation
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          ownerIds
          baseType
          updatedAt
        }
        orderItems {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentDeliveryStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        type
        transportationType
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        distance
        position
        trackingCode
        googleId
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
      ownerIds
    }
  }
`;
export const onCreateShipmentsOrderItems = /* GraphQL */ `
  subscription OnCreateShipmentsOrderItems(
    $filter: ModelSubscriptionShipmentsOrderItemsFilterInput
    $companyId: String
  ) {
    onCreateShipmentsOrderItems(filter: $filter, companyId: $companyId) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShipmentsOrderItems = /* GraphQL */ `
  subscription OnUpdateShipmentsOrderItems(
    $filter: ModelSubscriptionShipmentsOrderItemsFilterInput
    $companyId: String
  ) {
    onUpdateShipmentsOrderItems(filter: $filter, companyId: $companyId) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShipmentsOrderItems = /* GraphQL */ `
  subscription OnDeleteShipmentsOrderItems(
    $filter: ModelSubscriptionShipmentsOrderItemsFilterInput
    $companyId: String
  ) {
    onDeleteShipmentsOrderItems(filter: $filter, companyId: $companyId) {
      id
      companyId
      shipmentsID
      orderItemsID
      quantity
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        deliveryDate
        orderDate
        currentOrderStatus
        customerItemNumber
        customerReference
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        deliveries {
          items {
            id
            companyId
            deliveriesID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            comment
            deliveries {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
            ownerIds
          }
          nextToken
        }
        shipments {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        ordersID
        order {
          id
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdAt
          orderDate
          cancelled
          companyId
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          currentOrderStatus
          customerReference
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          deliveryDate {
            actual
            allItemsSet
            planned
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          items {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          orderNumber
          orderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          sapCompanyName
          sapConfirmedDeliveryDate
          predictiveDeliveryDate
          sapCustomerNumber
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          createdByUserId
          purchaseOrder
          shipments {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          baseType
          updatedAt
        }
        purchaseOrderItemsID
        manualPurchaseOrderItemsID
        purchaseOrderItemsM {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        purchaseOrderItems {
          id
          purchaseOrdersID
          purchaseOrder {
            id
            createdAt
            cancelled
            country
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            currentPurchaseOrderStatus
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            finishedDate
            manufacturerContactPersonUserId
            manufacturerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            manufacturerAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            purchaseOrderNumber
            sapReference
            sapSupplierNumber
            sapSupplierCompanyName
            confirmed
            openingRemark
            closingRemark
            plannedTransportationType
            discount {
              currency
              value
            }
            freightCost {
              currency
              value
            }
            paymentConditions
            title
            purchaseOrderStatusProcess {
              duration
              endAt
              name
              position
              startAt
            }
            salesConfirmationNumber
            items {
              items {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            googleId
            orderIdsGoogle
            baseType
            updatedAt
          }
          createdAt
          country
          companyID
          currentPurchaseOrderStatus
          finishedDate
          manufacturerItemNumber
          number
          quantity
          title
          price {
            currency
            value
          }
          ean
          weight {
            value
            unit
          }
          length {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          hsCode
          volume {
            value
            unit
          }
          sapLineNumber
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          orderNumberReference
          sapOrderLineNumberReference
          orderItems {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          orderItemsM {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              shipmentsID
              purchaseOrderItemsID
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity
              comment
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateShipmentsPurchaseOrderItems = /* GraphQL */ `
  subscription OnCreateShipmentsPurchaseOrderItems(
    $filter: ModelSubscriptionShipmentsPurchaseOrderItemsFilterInput
  ) {
    onCreateShipmentsPurchaseOrderItems(filter: $filter) {
      id
      shipmentsID
      purchaseOrderItemsID
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity
      comment
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateShipmentsPurchaseOrderItems = /* GraphQL */ `
  subscription OnUpdateShipmentsPurchaseOrderItems(
    $filter: ModelSubscriptionShipmentsPurchaseOrderItemsFilterInput
  ) {
    onUpdateShipmentsPurchaseOrderItems(filter: $filter) {
      id
      shipmentsID
      purchaseOrderItemsID
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity
      comment
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteShipmentsPurchaseOrderItems = /* GraphQL */ `
  subscription OnDeleteShipmentsPurchaseOrderItems(
    $filter: ModelSubscriptionShipmentsPurchaseOrderItemsFilterInput
  ) {
    onDeleteShipmentsPurchaseOrderItems(filter: $filter) {
      id
      shipmentsID
      purchaseOrderItemsID
      shipments {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity
      comment
      packings {
        quantityInUnit
        quantity
        countedQuantity
        type
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAnalytics = /* GraphQL */ `
  subscription OnCreateAnalytics(
    $filter: ModelSubscriptionAnalyticsFilterInput
  ) {
    onCreateAnalytics(filter: $filter) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAnalytics = /* GraphQL */ `
  subscription OnUpdateAnalytics(
    $filter: ModelSubscriptionAnalyticsFilterInput
  ) {
    onUpdateAnalytics(filter: $filter) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAnalytics = /* GraphQL */ `
  subscription OnDeleteAnalytics(
    $filter: ModelSubscriptionAnalyticsFilterInput
  ) {
    onDeleteAnalytics(filter: $filter) {
      id
      month
      year
      exchangeRates
      commodities
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDeliveries = /* GraphQL */ `
  subscription OnCreateDeliveries(
    $filter: ModelSubscriptionDeliveriesFilterInput
  ) {
    onCreateDeliveries(filter: $filter) {
      id
      createdAt
      size
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      trackingInformation
      positionNumber
      shipmentsID
      shipment {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      carrier {
        name
        code
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      currentDeliveryStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      type
      transportationType
      companyIds
      costs {
        currency
        value
      }
      etd
      eta
      distance
      position
      trackingCode
      googleId
      totalCargoWeight {
        value
        unit
      }
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const onUpdateDeliveries = /* GraphQL */ `
  subscription OnUpdateDeliveries(
    $filter: ModelSubscriptionDeliveriesFilterInput
  ) {
    onUpdateDeliveries(filter: $filter) {
      id
      createdAt
      size
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      trackingInformation
      positionNumber
      shipmentsID
      shipment {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      carrier {
        name
        code
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      currentDeliveryStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      type
      transportationType
      companyIds
      costs {
        currency
        value
      }
      etd
      eta
      distance
      position
      trackingCode
      googleId
      totalCargoWeight {
        value
        unit
      }
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const onDeleteDeliveries = /* GraphQL */ `
  subscription OnDeleteDeliveries(
    $filter: ModelSubscriptionDeliveriesFilterInput
  ) {
    onDeleteDeliveries(filter: $filter) {
      id
      createdAt
      size
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      trackingInformation
      positionNumber
      shipmentsID
      shipment {
        id
        size
        originCountry
        createdAt
        customsMrnNumber
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        freeText
        manualTracking
        trackingInformation
        positionNumber
        purchaseOrderItems {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        orderItems {
          items {
            id
            companyId
            shipmentsID
            orderItemsID
            quantity
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              deliveryDate
              orderDate
              currentOrderStatus
              customerItemNumber
              customerReference
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              deliveries {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              shipments {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              ordersID
              order {
                id
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdAt
                orderDate
                cancelled
                companyId
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                currentOrderStatus
                customerReference
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                deliveryDate {
                  actual
                  allItemsSet
                  planned
                }
                documents {
                  nextToken
                }
                items {
                  nextToken
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                orderNumber
                orderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                sapCompanyName
                sapConfirmedDeliveryDate
                predictiveDeliveryDate
                sapCustomerNumber
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                createdByUserId
                purchaseOrder
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                baseType
                updatedAt
              }
              purchaseOrderItemsID
              manualPurchaseOrderItemsID
              purchaseOrderItemsM {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        deliveriesID
        delivery {
          id
          createdAt
          size
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          trackingInformation
          positionNumber
          shipmentsID
          shipment {
            id
            size
            originCountry
            createdAt
            customsMrnNumber
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            freeText
            manualTracking
            trackingInformation
            positionNumber
            purchaseOrderItems {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            orderItems {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            deliveriesID
            delivery {
              id
              createdAt
              size
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              trackingInformation
              positionNumber
              shipmentsID
              shipment {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                items {
                  id
                  companyId
                  deliveriesID
                  orderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                  ownerIds
                }
                nextToken
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentDeliveryStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              type
              transportationType
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              distance
              position
              trackingCode
              googleId
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              ownerIds
              baseType
              updatedAt
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentShipmentStatus
            type
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            position
            googleId
            telexReleaseStatus
            customsClearanceStatus
            trackingCode
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            customsID
            customs {
              id
              currentCustomsStatus
              createdAt
              containerFreightCost {
                currency
                value
              }
              originCountry
              releaseDate
              positionNumber
              mrnNumber
              sentMrnNumber
              positions {
                hsCode
                itemDeclaration
                invoiceValue {
                  currency
                  value
                }
                tax {
                  currency
                  value
                }
                customsValue {
                  currency
                  value
                }
                iktValue {
                  currency
                  value
                }
                quantity
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
              }
              customsLocation
              weightNet {
                value
                unit
              }
              weightGross {
                value
                unit
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            items {
              id
              companyId
              deliveriesID
              orderItemsID
              quantity
              packings {
                quantityInUnit
                quantity
                countedQuantity
                type
              }
              comment
              deliveries {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              orderItems {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              createdAt
              updatedAt
              ownerIds
            }
            nextToken
          }
          carrier {
            name
            code
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          currentDeliveryStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          type
          transportationType
          companyIds
          costs {
            currency
            value
          }
          etd
          eta
          distance
          position
          trackingCode
          googleId
          totalCargoWeight {
            value
            unit
          }
          sustainabilityImpact {
            type
            from
            to
            distance
            totalCargoWeight {
              value
              unit
            }
            ewWellToWheel
            gwWellToWheel
            etTankToWheel
            gtTankToWheel
          }
          ownerIds
          baseType
          updatedAt
        }
        carrier {
          name
          code
        }
        history {
          date
          userId
          firstName
          lastName
          title
          message
          type
        }
        currentShipmentStatus
        type
        companyIds
        costs {
          currency
          value
        }
        etd
        eta
        position
        googleId
        telexReleaseStatus
        customsClearanceStatus
        trackingCode
        totalCargoWeight {
          value
          unit
        }
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        customsID
        customs {
          id
          currentCustomsStatus
          createdAt
          containerFreightCost {
            currency
            value
          }
          originCountry
          releaseDate
          positionNumber
          mrnNumber
          sentMrnNumber
          positions {
            hsCode
            itemDeclaration
            invoiceValue {
              currency
              value
            }
            tax {
              currency
              value
            }
            customsValue {
              currency
              value
            }
            iktValue {
              currency
              value
            }
            quantity
            weightNet {
              value
              unit
            }
            weightGross {
              value
              unit
            }
          }
          customsLocation
          weightNet {
            value
            unit
          }
          weightGross {
            value
            unit
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          shipments {
            items {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        ownerIds
        baseType
        updatedAt
      }
      orderItems {
        items {
          id
          companyId
          deliveriesID
          orderItemsID
          quantity
          packings {
            quantityInUnit
            quantity
            countedQuantity
            type
          }
          comment
          deliveries {
            id
            createdAt
            size
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            trackingInformation
            positionNumber
            shipmentsID
            shipment {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            orderItems {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            carrier {
              name
              code
            }
            history {
              date
              userId
              firstName
              lastName
              title
              message
              type
            }
            currentDeliveryStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            type
            transportationType
            companyIds
            costs {
              currency
              value
            }
            etd
            eta
            distance
            position
            trackingCode
            googleId
            totalCargoWeight {
              value
              unit
            }
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            ownerIds
            baseType
            updatedAt
          }
          orderItems {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          createdAt
          updatedAt
          ownerIds
        }
        nextToken
      }
      carrier {
        name
        code
      }
      history {
        date
        userId
        firstName
        lastName
        title
        message
        type
      }
      currentDeliveryStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      type
      transportationType
      companyIds
      costs {
        currency
        value
      }
      etd
      eta
      distance
      position
      trackingCode
      googleId
      totalCargoWeight {
        value
        unit
      }
      sustainabilityImpact {
        type
        from
        to
        distance
        totalCargoWeight {
          value
          unit
        }
        ewWellToWheel
        gwWellToWheel
        etTankToWheel
        gtTankToWheel
      }
      ownerIds
      baseType
      updatedAt
    }
  }
`;
export const onCreateDocuments = /* GraphQL */ `
  subscription OnCreateDocuments(
    $filter: ModelSubscriptionDocumentsFilterInput
    $country: String
    $companyId: String
  ) {
    onCreateDocuments(
      filter: $filter
      country: $country
      companyId: $companyId
    ) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      updatedAt
    }
  }
`;
export const onUpdateDocuments = /* GraphQL */ `
  subscription OnUpdateDocuments(
    $filter: ModelSubscriptionDocumentsFilterInput
    $country: String
    $companyId: String
  ) {
    onUpdateDocuments(
      filter: $filter
      country: $country
      companyId: $companyId
    ) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      updatedAt
    }
  }
`;
export const onDeleteDocuments = /* GraphQL */ `
  subscription OnDeleteDocuments(
    $filter: ModelSubscriptionDocumentsFilterInput
    $country: String
    $companyId: String
  ) {
    onDeleteDocuments(
      filter: $filter
      country: $country
      companyId: $companyId
    ) {
      id
      createdAt
      companyId
      companiesIDs
      collectionName
      storageKey
      type
      name
      fileType
      storageUrl
      countries
      country
      objectID
      updatedAt
    }
  }
`;
export const onCreateCompaniesAnalytics = /* GraphQL */ `
  subscription OnCreateCompaniesAnalytics(
    $filter: ModelSubscriptionCompaniesAnalyticsFilterInput
    $companyID: String
  ) {
    onCreateCompaniesAnalytics(filter: $filter, companyID: $companyID) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      companyID
      updatedAt
    }
  }
`;
export const onUpdateCompaniesAnalytics = /* GraphQL */ `
  subscription OnUpdateCompaniesAnalytics(
    $filter: ModelSubscriptionCompaniesAnalyticsFilterInput
    $companyID: String
  ) {
    onUpdateCompaniesAnalytics(filter: $filter, companyID: $companyID) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      companyID
      updatedAt
    }
  }
`;
export const onDeleteCompaniesAnalytics = /* GraphQL */ `
  subscription OnDeleteCompaniesAnalytics(
    $filter: ModelSubscriptionCompaniesAnalyticsFilterInput
    $companyID: String
  ) {
    onDeleteCompaniesAnalytics(filter: $filter, companyID: $companyID) {
      id
      year
      month
      createdAt
      quantityInvoices
      quantityOrders
      turnoverInvoices
      turnoverOrders
      productRequests
      customerRequests
      companyID
      updatedAt
    }
  }
`;
export const onCreateProductRequests = /* GraphQL */ `
  subscription OnCreateProductRequests(
    $filter: ModelSubscriptionProductRequestsFilterInput
  ) {
    onCreateProductRequests(filter: $filter) {
      id
      createdAt
      channel
      customerRequestsID
      customerRequests {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      priority
      involvedUsersIds
      countries
      involvedUsers {
        userId
        firstName
        lastName
        email
        country
      }
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      freeText
      customerCompanyID
      customerCompany {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      items {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      companyIds {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateProductRequests = /* GraphQL */ `
  subscription OnUpdateProductRequests(
    $filter: ModelSubscriptionProductRequestsFilterInput
  ) {
    onUpdateProductRequests(filter: $filter) {
      id
      createdAt
      channel
      customerRequestsID
      customerRequests {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      priority
      involvedUsersIds
      countries
      involvedUsers {
        userId
        firstName
        lastName
        email
        country
      }
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      freeText
      customerCompanyID
      customerCompany {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      items {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      companyIds {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteProductRequests = /* GraphQL */ `
  subscription OnDeleteProductRequests(
    $filter: ModelSubscriptionProductRequestsFilterInput
  ) {
    onDeleteProductRequests(filter: $filter) {
      id
      createdAt
      channel
      customerRequestsID
      customerRequests {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      priority
      involvedUsersIds
      countries
      involvedUsers {
        userId
        firstName
        lastName
        email
        country
      }
      dueDate
      currentProductRequestStatus
      positionNumber
      sentOverdueReminder
      title
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      freeText
      customerCompanyID
      customerCompany {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      items {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      companyIds {
        items {
          id
          companiesID
          productRequestsID
          companies {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          productRequests {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          createdAt
          updatedAt
          contactPersonUserId
          countryCode
          involvedUsersIds
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateItems = /* GraphQL */ `
  subscription OnCreateItems(
    $filter: ModelSubscriptionItemsFilterInput
    $companyID: String
  ) {
    onCreateItems(filter: $filter, companyID: $companyID) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      customerArticleNumber
      title
      description
      number
      ean
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      active
      properties {
        propertyId
        name
        values
      }
      itemsHeadID
      itemsHead {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      variant {
        optionName
        optionValues
      }
      customsRate
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      coverImageId
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      packagings {
        type
        quantity
        weight {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        length {
          value
          unit
        }
        volume {
          value
          unit
        }
      }
      productRequests {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      baseType
      categoryId
      qualityReportTemplates {
        items {
          id
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          categories
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onUpdateItems = /* GraphQL */ `
  subscription OnUpdateItems(
    $filter: ModelSubscriptionItemsFilterInput
    $companyID: String
  ) {
    onUpdateItems(filter: $filter, companyID: $companyID) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      customerArticleNumber
      title
      description
      number
      ean
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      active
      properties {
        propertyId
        name
        values
      }
      itemsHeadID
      itemsHead {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      variant {
        optionName
        optionValues
      }
      customsRate
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      coverImageId
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      packagings {
        type
        quantity
        weight {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        length {
          value
          unit
        }
        volume {
          value
          unit
        }
      }
      productRequests {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      baseType
      categoryId
      qualityReportTemplates {
        items {
          id
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          categories
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onDeleteItems = /* GraphQL */ `
  subscription OnDeleteItems(
    $filter: ModelSubscriptionItemsFilterInput
    $companyID: String
  ) {
    onDeleteItems(filter: $filter, companyID: $companyID) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      customerArticleNumber
      title
      description
      number
      ean
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      active
      properties {
        propertyId
        name
        values
      }
      itemsHeadID
      itemsHead {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        customsRate
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        options {
          optionName
          optionValues
        }
        coverImageId
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        variants {
          items {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          nextToken
        }
        baseType
        updatedAt
      }
      variant {
        optionName
        optionValues
      }
      customsRate
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      coverImageId
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      packagings {
        type
        quantity
        weight {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        length {
          value
          unit
        }
        volume {
          value
          unit
        }
      }
      productRequests {
        items {
          id
          productRequestsID
          itemsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          selectedPriceOffersId
          priceOffer
          priceOfferMoldCosts {
            currency
            value
          }
          productionTime
          deliveryType
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          targetPrice
          margin
          excludeAdditionalCosts
          containerSize
          airFreightCostsPerKilo
          transportCostWarehouseToCustomer
          workingCosts
          tiersId
          createdAt
          updatedAt
        }
        nextToken
      }
      priceOffers {
        items {
          id
          createdAt
          country
          price {
            currency
            value
          }
          currency
          additionalCosts {
            costs {
              currency
              value
            }
            type
          }
          productionTime
          currentPriceOffer
          quantity
          requestQuantity {
            value
            unit
          }
          minimumQuantity
          minimumOfferQuantity {
            value
            unit
          }
          companiesID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          tiers {
            tierId
            price {
              currency
              value
            }
          }
          updatedAt
        }
        nextToken
      }
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      baseType
      categoryId
      qualityReportTemplates {
        items {
          id
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          categories
          createdAt
          updatedAt
        }
        nextToken
      }
      qualityReports {
        items {
          id
          purchaseOrderItemsID
          purchaseOrderItems {
            id
            purchaseOrdersID
            purchaseOrder {
              id
              createdAt
              cancelled
              country
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              currentPurchaseOrderStatus
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              finishedDate
              manufacturerContactPersonUserId
              manufacturerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              manufacturerAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              purchaseOrderNumber
              sapReference
              sapSupplierNumber
              sapSupplierCompanyName
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              title
              purchaseOrderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              salesConfirmationNumber
              items {
                items {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                nextToken
              }
              googleId
              orderIdsGoogle
              baseType
              updatedAt
            }
            createdAt
            country
            companyID
            currentPurchaseOrderStatus
            finishedDate
            manufacturerItemNumber
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            orderNumberReference
            sapOrderLineNumberReference
            orderItems {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            orderItemsM {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                deliveryDate
                orderDate
                currentOrderStatus
                customerItemNumber
                customerReference
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                deliveries {
                  nextToken
                }
                shipments {
                  nextToken
                }
                ordersID
                order {
                  id
                  createdAt
                  orderDate
                  cancelled
                  companyId
                  contactPersonUserId
                  currentOrderStatus
                  customerReference
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  orderNumber
                  sapCompanyName
                  sapConfirmedDeliveryDate
                  predictiveDeliveryDate
                  sapCustomerNumber
                  createdByUserId
                  purchaseOrder
                  baseType
                  updatedAt
                }
                purchaseOrderItemsID
                manualPurchaseOrderItemsID
                purchaseOrderItemsM {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            shipments {
              items {
                id
                shipmentsID
                purchaseOrderItemsID
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                quantity
                comment
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          countries
          maxQuantityItemsToCheck
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          qualityReportItems {
            items {
              id
              countries
              qualityReportID
              testedItems
              createdAt
              updatedAt
            }
            nextToken
          }
          finalStatus
          finishedDate
          createdAt
          updatedAt
          baseType
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onCreateItemsHead = /* GraphQL */ `
  subscription OnCreateItemsHead(
    $filter: ModelSubscriptionItemsHeadFilterInput
    $companyID: String
  ) {
    onCreateItemsHead(filter: $filter, companyID: $companyID) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      customsRate
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      options {
        optionName
        optionValues
      }
      coverImageId
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      variants {
        items {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateItemsHead = /* GraphQL */ `
  subscription OnUpdateItemsHead(
    $filter: ModelSubscriptionItemsHeadFilterInput
    $companyID: String
  ) {
    onUpdateItemsHead(filter: $filter, companyID: $companyID) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      customsRate
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      options {
        optionName
        optionValues
      }
      coverImageId
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      variants {
        items {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteItemsHead = /* GraphQL */ `
  subscription OnDeleteItemsHead(
    $filter: ModelSubscriptionItemsHeadFilterInput
    $companyID: String
  ) {
    onDeleteItemsHead(filter: $filter, companyID: $companyID) {
      id
      companyIDs
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      createdAt
      hsCode
      tariffCode
      duties {
        id
        goodsCode
        goodsCodeCN
        duty
        duties {
          goodsCode
          goodsCodeCN
          addCode
          orderNo
          startDate
          endDate
          redInd
          origin
          measureType
          legalBase
          duty
          originCode
          measTypeCode
        }
        createdAt
        updatedAt
      }
      material
      customsRate
      translations {
        items {
          id
          createdAt
          languageCode
          companyIDs
          field
          translation
          translationSearch
          collectionName
          objectID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      options {
        optionName
        optionValues
      }
      coverImageId
      priceScreenings {
        items {
          id
          createdAt
          ipAddress
          device
          browser
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          searchTerm
          priceCalculationMin
          priceCalculationMax
          salesPriceMin {
            currency
            value
          }
          salesPriceMax {
            currency
            value
          }
          items {
            title
            url
            price {
              currency
              value
            }
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          updatedAt
        }
        nextToken
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      variants {
        items {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          customerArticleNumber
          title
          description
          number
          ean
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          active
          properties {
            propertyId
            name
            values
          }
          itemsHeadID
          itemsHead {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            customsRate
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            options {
              optionName
              optionValues
            }
            coverImageId
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            variants {
              items {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          variant {
            optionName
            optionValues
          }
          customsRate
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          coverImageId
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          packagings {
            type
            quantity
            weight {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            length {
              value
              unit
            }
            volume {
              value
              unit
            }
          }
          productRequests {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          baseType
          categoryId
          qualityReportTemplates {
            items {
              id
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              categories
              createdAt
              updatedAt
            }
            nextToken
          }
          qualityReports {
            items {
              id
              purchaseOrderItemsID
              purchaseOrderItems {
                id
                purchaseOrdersID
                purchaseOrder {
                  id
                  createdAt
                  cancelled
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerContactPersonUserId
                  purchaseOrderNumber
                  sapReference
                  sapSupplierNumber
                  sapSupplierCompanyName
                  confirmed
                  openingRemark
                  closingRemark
                  plannedTransportationType
                  paymentConditions
                  title
                  salesConfirmationNumber
                  googleId
                  orderIdsGoogle
                  baseType
                  updatedAt
                }
                createdAt
                country
                companyID
                currentPurchaseOrderStatus
                finishedDate
                manufacturerItemNumber
                number
                quantity
                title
                price {
                  currency
                  value
                }
                ean
                weight {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                hsCode
                volume {
                  value
                  unit
                }
                sapLineNumber
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                orderNumberReference
                sapOrderLineNumberReference
                orderItems {
                  nextToken
                }
                orderItemsM {
                  nextToken
                }
                shipments {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              countries
              maxQuantityItemsToCheck
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              qualityReportItems {
                items {
                  id
                  countries
                  qualityReportID
                  testedItems
                  createdAt
                  updatedAt
                }
                nextToken
              }
              finalStatus
              finishedDate
              createdAt
              updatedAt
              baseType
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateItemProperties = /* GraphQL */ `
  subscription OnCreateItemProperties(
    $filter: ModelSubscriptionItemPropertiesFilterInput
  ) {
    onCreateItemProperties(filter: $filter) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const onUpdateItemProperties = /* GraphQL */ `
  subscription OnUpdateItemProperties(
    $filter: ModelSubscriptionItemPropertiesFilterInput
  ) {
    onUpdateItemProperties(filter: $filter) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const onDeleteItemProperties = /* GraphQL */ `
  subscription OnDeleteItemProperties(
    $filter: ModelSubscriptionItemPropertiesFilterInput
  ) {
    onDeleteItemProperties(filter: $filter) {
      id
      createdAt
      property
      values
      updatedAt
    }
  }
`;
export const onCreateProductRequestsItems = /* GraphQL */ `
  subscription OnCreateProductRequestsItems(
    $filter: ModelSubscriptionProductRequestsItemsFilterInput
  ) {
    onCreateProductRequestsItems(filter: $filter) {
      id
      productRequestsID
      itemsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      selectedPriceOffersId
      priceOffer
      priceOfferMoldCosts {
        currency
        value
      }
      productionTime
      deliveryType
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      targetPrice
      margin
      excludeAdditionalCosts
      containerSize
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProductRequestsItems = /* GraphQL */ `
  subscription OnUpdateProductRequestsItems(
    $filter: ModelSubscriptionProductRequestsItemsFilterInput
  ) {
    onUpdateProductRequestsItems(filter: $filter) {
      id
      productRequestsID
      itemsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      selectedPriceOffersId
      priceOffer
      priceOfferMoldCosts {
        currency
        value
      }
      productionTime
      deliveryType
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      targetPrice
      margin
      excludeAdditionalCosts
      containerSize
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProductRequestsItems = /* GraphQL */ `
  subscription OnDeleteProductRequestsItems(
    $filter: ModelSubscriptionProductRequestsItemsFilterInput
  ) {
    onDeleteProductRequestsItems(filter: $filter) {
      id
      productRequestsID
      itemsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      selectedPriceOffersId
      priceOffer
      priceOfferMoldCosts {
        currency
        value
      }
      productionTime
      deliveryType
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      targetPrice
      margin
      excludeAdditionalCosts
      containerSize
      airFreightCostsPerKilo
      transportCostWarehouseToCustomer
      workingCosts
      tiersId
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePriceOffers = /* GraphQL */ `
  subscription OnCreatePriceOffers(
    $filter: ModelSubscriptionPriceOffersFilterInput
    $companiesID: String
    $country: String
  ) {
    onCreatePriceOffers(
      filter: $filter
      companiesID: $companiesID
      country: $country
    ) {
      id
      createdAt
      country
      price {
        currency
        value
      }
      currency
      additionalCosts {
        costs {
          currency
          value
        }
        type
      }
      productionTime
      currentPriceOffer
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      companiesID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      tiers {
        tierId
        price {
          currency
          value
        }
      }
      updatedAt
    }
  }
`;
export const onUpdatePriceOffers = /* GraphQL */ `
  subscription OnUpdatePriceOffers(
    $filter: ModelSubscriptionPriceOffersFilterInput
    $companiesID: String
    $country: String
  ) {
    onUpdatePriceOffers(
      filter: $filter
      companiesID: $companiesID
      country: $country
    ) {
      id
      createdAt
      country
      price {
        currency
        value
      }
      currency
      additionalCosts {
        costs {
          currency
          value
        }
        type
      }
      productionTime
      currentPriceOffer
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      companiesID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      tiers {
        tierId
        price {
          currency
          value
        }
      }
      updatedAt
    }
  }
`;
export const onDeletePriceOffers = /* GraphQL */ `
  subscription OnDeletePriceOffers(
    $filter: ModelSubscriptionPriceOffersFilterInput
    $companiesID: String
    $country: String
  ) {
    onDeletePriceOffers(
      filter: $filter
      companiesID: $companiesID
      country: $country
    ) {
      id
      createdAt
      country
      price {
        currency
        value
      }
      currency
      additionalCosts {
        costs {
          currency
          value
        }
        type
      }
      productionTime
      currentPriceOffer
      quantity
      requestQuantity {
        value
        unit
      }
      minimumQuantity
      minimumOfferQuantity {
        value
        unit
      }
      companiesID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      tiers {
        tierId
        price {
          currency
          value
        }
      }
      updatedAt
    }
  }
`;
export const onCreateFreightRates = /* GraphQL */ `
  subscription OnCreateFreightRates(
    $filter: ModelSubscriptionFreightRatesFilterInput
  ) {
    onCreateFreightRates(filter: $filter) {
      id
      createdAt
      containerSize
      from
      to
      rate {
        currency
        value
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateFreightRates = /* GraphQL */ `
  subscription OnUpdateFreightRates(
    $filter: ModelSubscriptionFreightRatesFilterInput
  ) {
    onUpdateFreightRates(filter: $filter) {
      id
      createdAt
      containerSize
      from
      to
      rate {
        currency
        value
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteFreightRates = /* GraphQL */ `
  subscription OnDeleteFreightRates(
    $filter: ModelSubscriptionFreightRatesFilterInput
  ) {
    onDeleteFreightRates(filter: $filter) {
      id
      createdAt
      containerSize
      from
      to
      rate {
        currency
        value
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateTranslations = /* GraphQL */ `
  subscription OnCreateTranslations(
    $filter: ModelSubscriptionTranslationsFilterInput
  ) {
    onCreateTranslations(filter: $filter) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onUpdateTranslations = /* GraphQL */ `
  subscription OnUpdateTranslations(
    $filter: ModelSubscriptionTranslationsFilterInput
  ) {
    onUpdateTranslations(filter: $filter) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onDeleteTranslations = /* GraphQL */ `
  subscription OnDeleteTranslations(
    $filter: ModelSubscriptionTranslationsFilterInput
  ) {
    onDeleteTranslations(filter: $filter) {
      id
      createdAt
      languageCode
      companyIDs
      field
      translation
      translationSearch
      collectionName
      objectID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onCreatePriceScreenings = /* GraphQL */ `
  subscription OnCreatePriceScreenings(
    $filter: ModelSubscriptionPriceScreeningsFilterInput
  ) {
    onCreatePriceScreenings(filter: $filter) {
      id
      createdAt
      ipAddress
      device
      browser
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      searchTerm
      priceCalculationMin
      priceCalculationMax
      salesPriceMin {
        currency
        value
      }
      salesPriceMax {
        currency
        value
      }
      items {
        title
        url
        price {
          currency
          value
        }
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onUpdatePriceScreenings = /* GraphQL */ `
  subscription OnUpdatePriceScreenings(
    $filter: ModelSubscriptionPriceScreeningsFilterInput
  ) {
    onUpdatePriceScreenings(filter: $filter) {
      id
      createdAt
      ipAddress
      device
      browser
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      searchTerm
      priceCalculationMin
      priceCalculationMax
      salesPriceMin {
        currency
        value
      }
      salesPriceMax {
        currency
        value
      }
      items {
        title
        url
        price {
          currency
          value
        }
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onDeletePriceScreenings = /* GraphQL */ `
  subscription OnDeletePriceScreenings(
    $filter: ModelSubscriptionPriceScreeningsFilterInput
  ) {
    onDeletePriceScreenings(filter: $filter) {
      id
      createdAt
      ipAddress
      device
      browser
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      searchTerm
      priceCalculationMin
      priceCalculationMax
      salesPriceMin {
        currency
        value
      }
      salesPriceMax {
        currency
        value
      }
      items {
        title
        url
        price {
          currency
          value
        }
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onCreateCustomerRequests = /* GraphQL */ `
  subscription OnCreateCustomerRequests(
    $filter: ModelSubscriptionCustomerRequestsFilterInput
    $contactPersonID: String
    $companyID: String
  ) {
    onCreateCustomerRequests(
      filter: $filter
      contactPersonID: $contactPersonID
      companyID: $companyID
    ) {
      id
      createdAt
      currentStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      customerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      notes
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      reference
      successfull
      hubspotDealId
      productRequestsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      salesOffers {
        items {
          id
          customerRequestID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          acceptedByUserID
          createdAt
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          contactPersonID
          decimalPlaces
          number
          productRequestsID
          paymentConditions
          deliveryConditions
          netSum {
            currency
            value
          }
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          deliveryTime
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          offerItems {
            items {
              id
              salesOffersID
              salesOffer {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              companyID
              createdAt
              title
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity {
                value
                unit
              }
              price {
                currency
                value
              }
              discount
              vat
              optional
              toolCosts {
                currency
                value
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              editable
              selected
              serviceTemplate
              updatedAt
            }
            nextToken
          }
          itemsSelectable
          deliveryCosts {
            currency
            value
          }
          deliveryVat
          declineReason
          declineComment
          internalComment
          externalComment
          customerReference
          status
          validUntil
          sentExpiringReminder
          updatedAt
        }
        nextToken
      }
      customerRequestItems {
        items {
          id
          createdAt
          companyID
          contactPersonID
          title
          description
          customerArticleNumber
          quantity {
            value
            unit
          }
          targetPrice {
            currency
            value
          }
          material
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          itemsID
          notes
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          customerRequestsID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        nextToken
      }
      messages {
        createdAt
        message
        sender
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateCustomerRequests = /* GraphQL */ `
  subscription OnUpdateCustomerRequests(
    $filter: ModelSubscriptionCustomerRequestsFilterInput
    $contactPersonID: String
    $companyID: String
  ) {
    onUpdateCustomerRequests(
      filter: $filter
      contactPersonID: $contactPersonID
      companyID: $companyID
    ) {
      id
      createdAt
      currentStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      customerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      notes
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      reference
      successfull
      hubspotDealId
      productRequestsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      salesOffers {
        items {
          id
          customerRequestID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          acceptedByUserID
          createdAt
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          contactPersonID
          decimalPlaces
          number
          productRequestsID
          paymentConditions
          deliveryConditions
          netSum {
            currency
            value
          }
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          deliveryTime
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          offerItems {
            items {
              id
              salesOffersID
              salesOffer {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              companyID
              createdAt
              title
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity {
                value
                unit
              }
              price {
                currency
                value
              }
              discount
              vat
              optional
              toolCosts {
                currency
                value
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              editable
              selected
              serviceTemplate
              updatedAt
            }
            nextToken
          }
          itemsSelectable
          deliveryCosts {
            currency
            value
          }
          deliveryVat
          declineReason
          declineComment
          internalComment
          externalComment
          customerReference
          status
          validUntil
          sentExpiringReminder
          updatedAt
        }
        nextToken
      }
      customerRequestItems {
        items {
          id
          createdAt
          companyID
          contactPersonID
          title
          description
          customerArticleNumber
          quantity {
            value
            unit
          }
          targetPrice {
            currency
            value
          }
          material
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          itemsID
          notes
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          customerRequestsID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        nextToken
      }
      messages {
        createdAt
        message
        sender
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteCustomerRequests = /* GraphQL */ `
  subscription OnDeleteCustomerRequests(
    $filter: ModelSubscriptionCustomerRequestsFilterInput
    $contactPersonID: String
    $companyID: String
  ) {
    onDeleteCustomerRequests(
      filter: $filter
      contactPersonID: $contactPersonID
      companyID: $companyID
    ) {
      id
      createdAt
      currentStatus
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      deliveryDate
      deliveryConditions
      number
      contactPersonID
      customerContactPersonID
      customerContactPerson {
        id
        companyID
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        userID
        user {
          id
          companyId
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          companyContactPersonUserId
          country
          contactPersonUserId
          email
          imageUrl
          lastLogin
          firstName
          lastName
          language
          mobil
          phone
          position
          notifications
          productTourStatus
          roleId
          role {
            id
            roleName
            type
            cognitoUserGroup
            permissions
            createdAt
            updatedAt
          }
          settings
          createdAt
          updatedAt
          countryCode
        }
        email
        firstName
        lastName
        mobil
        phone
        position
        countryCode
        createdAt
        updatedAt
      }
      notes
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      reference
      successfull
      hubspotDealId
      productRequestsID
      productRequest {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      salesOffers {
        items {
          id
          customerRequestID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          acceptedByUserID
          createdAt
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          contactPersonID
          decimalPlaces
          number
          productRequestsID
          paymentConditions
          deliveryConditions
          netSum {
            currency
            value
          }
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          deliveryTime
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          offerItems {
            items {
              id
              salesOffersID
              salesOffer {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              companyID
              createdAt
              title
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              quantity {
                value
                unit
              }
              price {
                currency
                value
              }
              discount
              vat
              optional
              toolCosts {
                currency
                value
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              editable
              selected
              serviceTemplate
              updatedAt
            }
            nextToken
          }
          itemsSelectable
          deliveryCosts {
            currency
            value
          }
          deliveryVat
          declineReason
          declineComment
          internalComment
          externalComment
          customerReference
          status
          validUntil
          sentExpiringReminder
          updatedAt
        }
        nextToken
      }
      customerRequestItems {
        items {
          id
          createdAt
          companyID
          contactPersonID
          title
          description
          customerArticleNumber
          quantity {
            value
            unit
          }
          targetPrice {
            currency
            value
          }
          material
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          width {
            value
            unit
          }
          length {
            value
            unit
          }
          height {
            value
            unit
          }
          itemsID
          notes
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          customerRequestsID
          customerRequest {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        nextToken
      }
      messages {
        createdAt
        message
        sender
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateCustomerRequestItems = /* GraphQL */ `
  subscription OnCreateCustomerRequestItems(
    $filter: ModelSubscriptionCustomerRequestItemsFilterInput
    $contactPersonID: String
    $companyID: String
  ) {
    onCreateCustomerRequestItems(
      filter: $filter
      contactPersonID: $contactPersonID
      companyID: $companyID
    ) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      quantity {
        value
        unit
      }
      targetPrice {
        currency
        value
      }
      material
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      itemsID
      notes
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      customerRequestsID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onUpdateCustomerRequestItems = /* GraphQL */ `
  subscription OnUpdateCustomerRequestItems(
    $filter: ModelSubscriptionCustomerRequestItemsFilterInput
    $contactPersonID: String
    $companyID: String
  ) {
    onUpdateCustomerRequestItems(
      filter: $filter
      contactPersonID: $contactPersonID
      companyID: $companyID
    ) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      quantity {
        value
        unit
      }
      targetPrice {
        currency
        value
      }
      material
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      itemsID
      notes
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      customerRequestsID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onDeleteCustomerRequestItems = /* GraphQL */ `
  subscription OnDeleteCustomerRequestItems(
    $filter: ModelSubscriptionCustomerRequestItemsFilterInput
    $contactPersonID: String
    $companyID: String
  ) {
    onDeleteCustomerRequestItems(
      filter: $filter
      contactPersonID: $contactPersonID
      companyID: $companyID
    ) {
      id
      createdAt
      companyID
      contactPersonID
      title
      description
      customerArticleNumber
      quantity {
        value
        unit
      }
      targetPrice {
        currency
        value
      }
      material
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      width {
        value
        unit
      }
      length {
        value
        unit
      }
      height {
        value
        unit
      }
      itemsID
      notes
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      customerRequestsID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      baseType
      updatedAt
    }
  }
`;
export const onCreateSalesOffer = /* GraphQL */ `
  subscription OnCreateSalesOffer(
    $filter: ModelSubscriptionSalesOfferFilterInput
    $companyID: String
  ) {
    onCreateSalesOffer(filter: $filter, companyID: $companyID) {
      id
      customerRequestID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      acceptedByUserID
      createdAt
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      netSum {
        currency
        value
      }
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      deliveryTime
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      offerItems {
        items {
          id
          salesOffersID
          salesOffer {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          companyID
          createdAt
          title
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity {
            value
            unit
          }
          price {
            currency
            value
          }
          discount
          vat
          optional
          toolCosts {
            currency
            value
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          editable
          selected
          serviceTemplate
          updatedAt
        }
        nextToken
      }
      itemsSelectable
      deliveryCosts {
        currency
        value
      }
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      updatedAt
    }
  }
`;
export const onUpdateSalesOffer = /* GraphQL */ `
  subscription OnUpdateSalesOffer(
    $filter: ModelSubscriptionSalesOfferFilterInput
    $companyID: String
  ) {
    onUpdateSalesOffer(filter: $filter, companyID: $companyID) {
      id
      customerRequestID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      acceptedByUserID
      createdAt
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      netSum {
        currency
        value
      }
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      deliveryTime
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      offerItems {
        items {
          id
          salesOffersID
          salesOffer {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          companyID
          createdAt
          title
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity {
            value
            unit
          }
          price {
            currency
            value
          }
          discount
          vat
          optional
          toolCosts {
            currency
            value
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          editable
          selected
          serviceTemplate
          updatedAt
        }
        nextToken
      }
      itemsSelectable
      deliveryCosts {
        currency
        value
      }
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      updatedAt
    }
  }
`;
export const onDeleteSalesOffer = /* GraphQL */ `
  subscription OnDeleteSalesOffer(
    $filter: ModelSubscriptionSalesOfferFilterInput
    $companyID: String
  ) {
    onDeleteSalesOffer(filter: $filter, companyID: $companyID) {
      id
      customerRequestID
      customerRequest {
        id
        createdAt
        currentStatus
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        deliveryDate
        deliveryConditions
        number
        contactPersonID
        customerContactPersonID
        customerContactPerson {
          id
          companyID
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          userID
          user {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          email
          firstName
          lastName
          mobil
          phone
          position
          countryCode
          createdAt
          updatedAt
        }
        notes
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        reference
        successfull
        hubspotDealId
        productRequestsID
        productRequest {
          id
          createdAt
          channel
          customerRequestsID
          customerRequests {
            id
            createdAt
            currentStatus
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            deliveryDate
            deliveryConditions
            number
            contactPersonID
            customerContactPersonID
            customerContactPerson {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            notes
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            reference
            successfull
            hubspotDealId
            productRequestsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            salesOffers {
              items {
                id
                customerRequestID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                acceptedByUserID
                createdAt
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                contactPersonID
                decimalPlaces
                number
                productRequestsID
                paymentConditions
                deliveryConditions
                netSum {
                  currency
                  value
                }
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                deliveryTime
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                offerItems {
                  nextToken
                }
                itemsSelectable
                deliveryCosts {
                  currency
                  value
                }
                deliveryVat
                declineReason
                declineComment
                internalComment
                externalComment
                customerReference
                status
                validUntil
                sentExpiringReminder
                updatedAt
              }
              nextToken
            }
            customerRequestItems {
              items {
                id
                createdAt
                companyID
                contactPersonID
                title
                description
                customerArticleNumber
                quantity {
                  value
                  unit
                }
                targetPrice {
                  currency
                  value
                }
                material
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                itemsID
                notes
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                customerRequestsID
                customerRequest {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                documents {
                  nextToken
                }
                baseType
                updatedAt
              }
              nextToken
            }
            messages {
              createdAt
              message
              sender
            }
            baseType
            updatedAt
          }
          priority
          involvedUsersIds
          countries
          involvedUsers {
            userId
            firstName
            lastName
            email
            country
          }
          dueDate
          currentProductRequestStatus
          positionNumber
          sentOverdueReminder
          title
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          freeText
          customerCompanyID
          customerCompany {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          items {
            items {
              id
              productRequestsID
              itemsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              selectedPriceOffersId
              priceOffer
              priceOfferMoldCosts {
                currency
                value
              }
              productionTime
              deliveryType
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              targetPrice
              margin
              excludeAdditionalCosts
              containerSize
              airFreightCostsPerKilo
              transportCostWarehouseToCustomer
              workingCosts
              tiersId
              createdAt
              updatedAt
            }
            nextToken
          }
          companyIds {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          baseType
          updatedAt
        }
        salesOffers {
          items {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          nextToken
        }
        customerRequestItems {
          items {
            id
            createdAt
            companyID
            contactPersonID
            title
            description
            customerArticleNumber
            quantity {
              value
              unit
            }
            targetPrice {
              currency
              value
            }
            material
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            itemsID
            notes
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            customerRequestsID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            baseType
            updatedAt
          }
          nextToken
        }
        messages {
          createdAt
          message
          sender
        }
        baseType
        updatedAt
      }
      acceptedByUserID
      createdAt
      companyID
      company {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      contactPersonID
      decimalPlaces
      number
      productRequestsID
      paymentConditions
      deliveryConditions
      netSum {
        currency
        value
      }
      shippingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      deliveryTime
      billingAddress {
        additionalInformation
        company
        firstName
        lastName
        building
        city
        countryCode
        primary
        primaryBilling
        primaryShipping
        province
        room
        state
        street
        zip
      }
      offerItems {
        items {
          id
          salesOffersID
          salesOffer {
            id
            customerRequestID
            customerRequest {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            acceptedByUserID
            createdAt
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            contactPersonID
            decimalPlaces
            number
            productRequestsID
            paymentConditions
            deliveryConditions
            netSum {
              currency
              value
            }
            shippingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            deliveryTime
            billingAddress {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            offerItems {
              items {
                id
                salesOffersID
                salesOffer {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                companyID
                createdAt
                title
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                quantity {
                  value
                  unit
                }
                price {
                  currency
                  value
                }
                discount
                vat
                optional
                toolCosts {
                  currency
                  value
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                editable
                selected
                serviceTemplate
                updatedAt
              }
              nextToken
            }
            itemsSelectable
            deliveryCosts {
              currency
              value
            }
            deliveryVat
            declineReason
            declineComment
            internalComment
            externalComment
            customerReference
            status
            validUntil
            sentExpiringReminder
            updatedAt
          }
          companyID
          createdAt
          title
          itemsID
          item {
            id
            companyIDs
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            customerArticleNumber
            title
            description
            number
            ean
            width {
              value
              unit
            }
            length {
              value
              unit
            }
            height {
              value
              unit
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            active
            properties {
              propertyId
              name
              values
            }
            itemsHeadID
            itemsHead {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              customsRate
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              options {
                optionName
                optionValues
              }
              coverImageId
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              variants {
                items {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            variant {
              optionName
              optionValues
            }
            customsRate
            hsCode
            tariffCode
            duties {
              id
              goodsCode
              goodsCodeCN
              duty
              duties {
                goodsCode
                goodsCodeCN
                addCode
                orderNo
                startDate
                endDate
                redInd
                origin
                measureType
                legalBase
                duty
                originCode
                measTypeCode
              }
              createdAt
              updatedAt
            }
            material
            coverImageId
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            packagings {
              type
              quantity
              weight {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              length {
                value
                unit
              }
              volume {
                value
                unit
              }
            }
            productRequests {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            priceScreenings {
              items {
                id
                createdAt
                ipAddress
                device
                browser
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                searchTerm
                priceCalculationMin
                priceCalculationMax
                salesPriceMin {
                  currency
                  value
                }
                salesPriceMax {
                  currency
                  value
                }
                items {
                  title
                  url
                }
                documents {
                  nextToken
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            baseType
            categoryId
            qualityReportTemplates {
              items {
                id
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                categories
                createdAt
                updatedAt
              }
              nextToken
            }
            qualityReports {
              items {
                id
                purchaseOrderItemsID
                purchaseOrderItems {
                  id
                  purchaseOrdersID
                  createdAt
                  country
                  companyID
                  currentPurchaseOrderStatus
                  finishedDate
                  manufacturerItemNumber
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  orderNumberReference
                  sapOrderLineNumberReference
                  updatedAt
                }
                countries
                maxQuantityItemsToCheck
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                qualityReportItems {
                  nextToken
                }
                finalStatus
                finishedDate
                createdAt
                updatedAt
                baseType
              }
              nextToken
            }
            updatedAt
          }
          quantity {
            value
            unit
          }
          price {
            currency
            value
          }
          discount
          vat
          optional
          toolCosts {
            currency
            value
          }
          weight {
            value
            unit
          }
          volume {
            value
            unit
          }
          editable
          selected
          serviceTemplate
          updatedAt
        }
        nextToken
      }
      itemsSelectable
      deliveryCosts {
        currency
        value
      }
      deliveryVat
      declineReason
      declineComment
      internalComment
      externalComment
      customerReference
      status
      validUntil
      sentExpiringReminder
      updatedAt
    }
  }
`;
export const onCreateSalesOfferItems = /* GraphQL */ `
  subscription OnCreateSalesOfferItems(
    $filter: ModelSubscriptionSalesOfferItemsFilterInput
    $companyID: String
  ) {
    onCreateSalesOfferItems(filter: $filter, companyID: $companyID) {
      id
      salesOffersID
      salesOffer {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      companyID
      createdAt
      title
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity {
        value
        unit
      }
      price {
        currency
        value
      }
      discount
      vat
      optional
      toolCosts {
        currency
        value
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      editable
      selected
      serviceTemplate
      updatedAt
    }
  }
`;
export const onUpdateSalesOfferItems = /* GraphQL */ `
  subscription OnUpdateSalesOfferItems(
    $filter: ModelSubscriptionSalesOfferItemsFilterInput
    $companyID: String
  ) {
    onUpdateSalesOfferItems(filter: $filter, companyID: $companyID) {
      id
      salesOffersID
      salesOffer {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      companyID
      createdAt
      title
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity {
        value
        unit
      }
      price {
        currency
        value
      }
      discount
      vat
      optional
      toolCosts {
        currency
        value
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      editable
      selected
      serviceTemplate
      updatedAt
    }
  }
`;
export const onDeleteSalesOfferItems = /* GraphQL */ `
  subscription OnDeleteSalesOfferItems(
    $filter: ModelSubscriptionSalesOfferItemsFilterInput
    $companyID: String
  ) {
    onDeleteSalesOfferItems(filter: $filter, companyID: $companyID) {
      id
      salesOffersID
      salesOffer {
        id
        customerRequestID
        customerRequest {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        acceptedByUserID
        createdAt
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        contactPersonID
        decimalPlaces
        number
        productRequestsID
        paymentConditions
        deliveryConditions
        netSum {
          currency
          value
        }
        shippingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        deliveryTime
        billingAddress {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        offerItems {
          items {
            id
            salesOffersID
            salesOffer {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            companyID
            createdAt
            title
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity {
              value
              unit
            }
            price {
              currency
              value
            }
            discount
            vat
            optional
            toolCosts {
              currency
              value
            }
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            editable
            selected
            serviceTemplate
            updatedAt
          }
          nextToken
        }
        itemsSelectable
        deliveryCosts {
          currency
          value
        }
        deliveryVat
        declineReason
        declineComment
        internalComment
        externalComment
        customerReference
        status
        validUntil
        sentExpiringReminder
        updatedAt
      }
      companyID
      createdAt
      title
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      quantity {
        value
        unit
      }
      price {
        currency
        value
      }
      discount
      vat
      optional
      toolCosts {
        currency
        value
      }
      weight {
        value
        unit
      }
      volume {
        value
        unit
      }
      editable
      selected
      serviceTemplate
      updatedAt
    }
  }
`;
export const onCreateCommunicationMessages = /* GraphQL */ `
  subscription OnCreateCommunicationMessages(
    $filter: ModelSubscriptionCommunicationMessagesFilterInput
    $companyID: String
    $contactPersonUserId: String
    $userID: String
  ) {
    onCreateCommunicationMessages(
      filter: $filter
      companyID: $companyID
      contactPersonUserId: $contactPersonUserId
      userID: $userID
    ) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      messageUser {
        firstName
        lastName
      }
      objectID
      objectType
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      content
      reactions {
        users {
          firstName
          lastName
        }
        reaction
      }
      mentionedUsers {
        firstName
        lastName
      }
    }
  }
`;
export const onUpdateCommunicationMessages = /* GraphQL */ `
  subscription OnUpdateCommunicationMessages(
    $filter: ModelSubscriptionCommunicationMessagesFilterInput
    $companyID: String
    $contactPersonUserId: String
    $userID: String
  ) {
    onUpdateCommunicationMessages(
      filter: $filter
      companyID: $companyID
      contactPersonUserId: $contactPersonUserId
      userID: $userID
    ) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      messageUser {
        firstName
        lastName
      }
      objectID
      objectType
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      content
      reactions {
        users {
          firstName
          lastName
        }
        reaction
      }
      mentionedUsers {
        firstName
        lastName
      }
    }
  }
`;
export const onDeleteCommunicationMessages = /* GraphQL */ `
  subscription OnDeleteCommunicationMessages(
    $filter: ModelSubscriptionCommunicationMessagesFilterInput
    $companyID: String
    $contactPersonUserId: String
    $userID: String
  ) {
    onDeleteCommunicationMessages(
      filter: $filter
      companyID: $companyID
      contactPersonUserId: $contactPersonUserId
      userID: $userID
    ) {
      id
      countries
      companyID
      userID
      contactPersonUserId
      contactPerson {
        id
        email
        imageUrl
        firstName
        lastName
        mobil
        phone
        position
        hubspotId
        countries
        type
        funnel
        createdAt
        updatedAt
      }
      user {
        id
        companyId
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        companyContactPersonUserId
        country
        contactPersonUserId
        email
        imageUrl
        lastLogin
        firstName
        lastName
        language
        mobil
        phone
        position
        notifications
        productTourStatus
        roleId
        role {
          id
          roleName
          type
          cognitoUserGroup
          permissions
          createdAt
          updatedAt
        }
        settings
        createdAt
        updatedAt
        countryCode
      }
      messageUser {
        firstName
        lastName
      }
      objectID
      objectType
      documents {
        items {
          id
          createdAt
          companyId
          companiesIDs
          collectionName
          storageKey
          type
          name
          fileType
          storageUrl
          countries
          country
          objectID
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      content
      reactions {
        users {
          firstName
          lastName
        }
        reaction
      }
      mentionedUsers {
        firstName
        lastName
      }
    }
  }
`;
export const onCreateHsCodes = /* GraphQL */ `
  subscription OnCreateHsCodes($filter: ModelSubscriptionHsCodesFilterInput) {
    onCreateHsCodes(filter: $filter) {
      id
      goodsCode
      goodsCodeCN
      duty
      duties {
        goodsCode
        goodsCodeCN
        addCode
        orderNo
        startDate
        endDate
        redInd
        origin
        measureType
        legalBase
        duty
        originCode
        measTypeCode
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateHsCodes = /* GraphQL */ `
  subscription OnUpdateHsCodes($filter: ModelSubscriptionHsCodesFilterInput) {
    onUpdateHsCodes(filter: $filter) {
      id
      goodsCode
      goodsCodeCN
      duty
      duties {
        goodsCode
        goodsCodeCN
        addCode
        orderNo
        startDate
        endDate
        redInd
        origin
        measureType
        legalBase
        duty
        originCode
        measTypeCode
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteHsCodes = /* GraphQL */ `
  subscription OnDeleteHsCodes($filter: ModelSubscriptionHsCodesFilterInput) {
    onDeleteHsCodes(filter: $filter) {
      id
      goodsCode
      goodsCodeCN
      duty
      duties {
        goodsCode
        goodsCodeCN
        addCode
        orderNo
        startDate
        endDate
        redInd
        origin
        measureType
        legalBase
        duty
        originCode
        measTypeCode
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateQualityReports = /* GraphQL */ `
  subscription OnCreateQualityReports(
    $filter: ModelSubscriptionQualityReportsFilterInput
  ) {
    onCreateQualityReports(filter: $filter) {
      id
      purchaseOrderItemsID
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      countries
      maxQuantityItemsToCheck
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      qualityReportItems {
        items {
          id
          countries
          qualityReportID
          testedItems
          createdAt
          updatedAt
        }
        nextToken
      }
      finalStatus
      finishedDate
      createdAt
      updatedAt
      baseType
    }
  }
`;
export const onUpdateQualityReports = /* GraphQL */ `
  subscription OnUpdateQualityReports(
    $filter: ModelSubscriptionQualityReportsFilterInput
  ) {
    onUpdateQualityReports(filter: $filter) {
      id
      purchaseOrderItemsID
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      countries
      maxQuantityItemsToCheck
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      qualityReportItems {
        items {
          id
          countries
          qualityReportID
          testedItems
          createdAt
          updatedAt
        }
        nextToken
      }
      finalStatus
      finishedDate
      createdAt
      updatedAt
      baseType
    }
  }
`;
export const onDeleteQualityReports = /* GraphQL */ `
  subscription OnDeleteQualityReports(
    $filter: ModelSubscriptionQualityReportsFilterInput
  ) {
    onDeleteQualityReports(filter: $filter) {
      id
      purchaseOrderItemsID
      purchaseOrderItems {
        id
        purchaseOrdersID
        purchaseOrder {
          id
          createdAt
          cancelled
          country
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          currentPurchaseOrderStatus
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          finishedDate
          manufacturerContactPersonUserId
          manufacturerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          manufacturerAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          history {
            date
            userId
            firstName
            lastName
            title
            message
            type
          }
          purchaseOrderNumber
          sapReference
          sapSupplierNumber
          sapSupplierCompanyName
          confirmed
          openingRemark
          closingRemark
          plannedTransportationType
          discount {
            currency
            value
          }
          freightCost {
            currency
            value
          }
          paymentConditions
          title
          purchaseOrderStatusProcess {
            duration
            endAt
            name
            position
            startAt
          }
          salesConfirmationNumber
          items {
            items {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          googleId
          orderIdsGoogle
          baseType
          updatedAt
        }
        createdAt
        country
        companyID
        currentPurchaseOrderStatus
        finishedDate
        manufacturerItemNumber
        number
        quantity
        title
        price {
          currency
          value
        }
        ean
        weight {
          value
          unit
        }
        length {
          value
          unit
        }
        width {
          value
          unit
        }
        height {
          value
          unit
        }
        hsCode
        volume {
          value
          unit
        }
        sapLineNumber
        sustainabilityImpact {
          type
          from
          to
          distance
          totalCargoWeight {
            value
            unit
          }
          ewWellToWheel
          gwWellToWheel
          etTankToWheel
          gtTankToWheel
        }
        orderNumberReference
        sapOrderLineNumberReference
        orderItems {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        orderItemsM {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            createdAt
            deliveryDate
            orderDate
            currentOrderStatus
            customerItemNumber
            customerReference
            number
            quantity
            title
            price {
              currency
              value
            }
            ean
            weight {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            height {
              value
              unit
            }
            hsCode
            volume {
              value
              unit
            }
            sapLineNumber
            sustainabilityImpact {
              type
              from
              to
              distance
              totalCargoWeight {
                value
                unit
              }
              ewWellToWheel
              gwWellToWheel
              etTankToWheel
              gtTankToWheel
            }
            deliveries {
              items {
                id
                companyId
                deliveriesID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                comment
                deliveries {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
                ownerIds
              }
              nextToken
            }
            shipments {
              items {
                id
                companyId
                shipmentsID
                orderItemsID
                quantity
                packings {
                  quantityInUnit
                  quantity
                  countedQuantity
                  type
                }
                shipments {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            ordersID
            order {
              id
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdAt
              orderDate
              cancelled
              companyId
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              currentOrderStatus
              customerReference
              confirmed
              openingRemark
              closingRemark
              plannedTransportationType
              discount {
                currency
                value
              }
              freightCost {
                currency
                value
              }
              paymentConditions
              deliveryDate {
                actual
                allItemsSet
                planned
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              items {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              orderNumber
              orderStatusProcess {
                duration
                endAt
                name
                position
                startAt
              }
              sapCompanyName
              sapConfirmedDeliveryDate
              predictiveDeliveryDate
              sapCustomerNumber
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              createdByUserId
              purchaseOrder
              shipments {
                id
                size
                originCountry
                createdAt
                customsMrnNumber
                documents {
                  nextToken
                }
                freeText
                manualTracking
                trackingInformation
                positionNumber
                purchaseOrderItems {
                  nextToken
                }
                orderItems {
                  nextToken
                }
                deliveriesID
                delivery {
                  id
                  createdAt
                  size
                  trackingInformation
                  positionNumber
                  shipmentsID
                  currentDeliveryStatus
                  type
                  transportationType
                  companyIds
                  etd
                  eta
                  distance
                  position
                  trackingCode
                  googleId
                  ownerIds
                  baseType
                  updatedAt
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentShipmentStatus
                type
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                position
                googleId
                telexReleaseStatus
                customsClearanceStatus
                trackingCode
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                customsID
                customs {
                  id
                  currentCustomsStatus
                  createdAt
                  originCountry
                  releaseDate
                  positionNumber
                  mrnNumber
                  sentMrnNumber
                  customsLocation
                  baseType
                  updatedAt
                }
                ownerIds
                baseType
                updatedAt
              }
              baseType
              updatedAt
            }
            purchaseOrderItemsID
            manualPurchaseOrderItemsID
            purchaseOrderItemsM {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        shipments {
          items {
            id
            shipmentsID
            purchaseOrderItemsID
            shipments {
              id
              size
              originCountry
              createdAt
              customsMrnNumber
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              manualTracking
              trackingInformation
              positionNumber
              purchaseOrderItems {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              orderItems {
                items {
                  id
                  companyId
                  shipmentsID
                  orderItemsID
                  quantity
                  createdAt
                  updatedAt
                }
                nextToken
              }
              deliveriesID
              delivery {
                id
                createdAt
                size
                documents {
                  nextToken
                }
                trackingInformation
                positionNumber
                shipmentsID
                shipment {
                  id
                  size
                  originCountry
                  createdAt
                  customsMrnNumber
                  freeText
                  manualTracking
                  trackingInformation
                  positionNumber
                  deliveriesID
                  currentShipmentStatus
                  type
                  companyIds
                  etd
                  eta
                  position
                  googleId
                  telexReleaseStatus
                  customsClearanceStatus
                  trackingCode
                  customsID
                  ownerIds
                  baseType
                  updatedAt
                }
                orderItems {
                  nextToken
                }
                carrier {
                  name
                  code
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                currentDeliveryStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                type
                transportationType
                companyIds
                costs {
                  currency
                  value
                }
                etd
                eta
                distance
                position
                trackingCode
                googleId
                totalCargoWeight {
                  value
                  unit
                }
                sustainabilityImpact {
                  type
                  from
                  to
                  distance
                  ewWellToWheel
                  gwWellToWheel
                  etTankToWheel
                  gtTankToWheel
                }
                ownerIds
                baseType
                updatedAt
              }
              carrier {
                name
                code
              }
              history {
                date
                userId
                firstName
                lastName
                title
                message
                type
              }
              currentShipmentStatus
              type
              companyIds
              costs {
                currency
                value
              }
              etd
              eta
              position
              googleId
              telexReleaseStatus
              customsClearanceStatus
              trackingCode
              totalCargoWeight {
                value
                unit
              }
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              customsID
              customs {
                id
                currentCustomsStatus
                createdAt
                containerFreightCost {
                  currency
                  value
                }
                originCountry
                releaseDate
                positionNumber
                mrnNumber
                sentMrnNumber
                positions {
                  hsCode
                  itemDeclaration
                  quantity
                }
                customsLocation
                weightNet {
                  value
                  unit
                }
                weightGross {
                  value
                  unit
                }
                documents {
                  nextToken
                }
                shipments {
                  nextToken
                }
                baseType
                updatedAt
              }
              ownerIds
              baseType
              updatedAt
            }
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            quantity
            comment
            packings {
              quantityInUnit
              quantity
              countedQuantity
              type
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      countries
      maxQuantityItemsToCheck
      itemsID
      item {
        id
        companyIDs
        companyID
        company {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        createdAt
        customerArticleNumber
        title
        description
        number
        ean
        width {
          value
          unit
        }
        length {
          value
          unit
        }
        height {
          value
          unit
        }
        weight {
          value
          unit
        }
        volume {
          value
          unit
        }
        active
        properties {
          propertyId
          name
          values
        }
        itemsHeadID
        itemsHead {
          id
          companyIDs
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          createdAt
          hsCode
          tariffCode
          duties {
            id
            goodsCode
            goodsCodeCN
            duty
            duties {
              goodsCode
              goodsCodeCN
              addCode
              orderNo
              startDate
              endDate
              redInd
              origin
              measureType
              legalBase
              duty
              originCode
              measTypeCode
            }
            createdAt
            updatedAt
          }
          material
          customsRate
          translations {
            items {
              id
              createdAt
              languageCode
              companyIDs
              field
              translation
              translationSearch
              collectionName
              objectID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          options {
            optionName
            optionValues
          }
          coverImageId
          priceScreenings {
            items {
              id
              createdAt
              ipAddress
              device
              browser
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              searchTerm
              priceCalculationMin
              priceCalculationMax
              salesPriceMin {
                currency
                value
              }
              salesPriceMax {
                currency
                value
              }
              items {
                title
                url
                price {
                  currency
                  value
                }
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          variants {
            items {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            nextToken
          }
          baseType
          updatedAt
        }
        variant {
          optionName
          optionValues
        }
        customsRate
        hsCode
        tariffCode
        duties {
          id
          goodsCode
          goodsCodeCN
          duty
          duties {
            goodsCode
            goodsCodeCN
            addCode
            orderNo
            startDate
            endDate
            redInd
            origin
            measureType
            legalBase
            duty
            originCode
            measTypeCode
          }
          createdAt
          updatedAt
        }
        material
        coverImageId
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        packagings {
          type
          quantity
          weight {
            value
            unit
          }
          width {
            value
            unit
          }
          height {
            value
            unit
          }
          length {
            value
            unit
          }
          volume {
            value
            unit
          }
        }
        productRequests {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        priceScreenings {
          items {
            id
            createdAt
            ipAddress
            device
            browser
            weight {
              value
              unit
            }
            volume {
              value
              unit
            }
            searchTerm
            priceCalculationMin
            priceCalculationMax
            salesPriceMin {
              currency
              value
            }
            salesPriceMax {
              currency
              value
            }
            items {
              title
              url
              price {
                currency
                value
              }
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        baseType
        categoryId
        qualityReportTemplates {
          items {
            id
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            categories
            createdAt
            updatedAt
          }
          nextToken
        }
        qualityReports {
          items {
            id
            purchaseOrderItemsID
            purchaseOrderItems {
              id
              purchaseOrdersID
              purchaseOrder {
                id
                createdAt
                cancelled
                country
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                currentPurchaseOrderStatus
                documents {
                  nextToken
                }
                finishedDate
                manufacturerContactPersonUserId
                manufacturerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                manufacturerAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                history {
                  date
                  userId
                  firstName
                  lastName
                  title
                  message
                  type
                }
                purchaseOrderNumber
                sapReference
                sapSupplierNumber
                sapSupplierCompanyName
                confirmed
                openingRemark
                closingRemark
                plannedTransportationType
                discount {
                  currency
                  value
                }
                freightCost {
                  currency
                  value
                }
                paymentConditions
                title
                purchaseOrderStatusProcess {
                  duration
                  endAt
                  name
                  position
                  startAt
                }
                salesConfirmationNumber
                items {
                  nextToken
                }
                googleId
                orderIdsGoogle
                baseType
                updatedAt
              }
              createdAt
              country
              companyID
              currentPurchaseOrderStatus
              finishedDate
              manufacturerItemNumber
              number
              quantity
              title
              price {
                currency
                value
              }
              ean
              weight {
                value
                unit
              }
              length {
                value
                unit
              }
              width {
                value
                unit
              }
              height {
                value
                unit
              }
              hsCode
              volume {
                value
                unit
              }
              sapLineNumber
              sustainabilityImpact {
                type
                from
                to
                distance
                totalCargoWeight {
                  value
                  unit
                }
                ewWellToWheel
                gwWellToWheel
                etTankToWheel
                gtTankToWheel
              }
              orderNumberReference
              sapOrderLineNumberReference
              orderItems {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              orderItemsM {
                items {
                  id
                  companyId
                  createdAt
                  deliveryDate
                  orderDate
                  currentOrderStatus
                  customerItemNumber
                  customerReference
                  number
                  quantity
                  title
                  ean
                  hsCode
                  sapLineNumber
                  ordersID
                  purchaseOrderItemsID
                  manualPurchaseOrderItemsID
                  updatedAt
                }
                nextToken
              }
              shipments {
                items {
                  id
                  shipmentsID
                  purchaseOrderItemsID
                  quantity
                  comment
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            countries
            maxQuantityItemsToCheck
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            qualityReportItems {
              items {
                id
                countries
                qualityReportID
                testedItems
                createdAt
                updatedAt
              }
              nextToken
            }
            finalStatus
            finishedDate
            createdAt
            updatedAt
            baseType
          }
          nextToken
        }
        updatedAt
      }
      qualityReportItems {
        items {
          id
          countries
          qualityReportID
          testedItems
          createdAt
          updatedAt
        }
        nextToken
      }
      finalStatus
      finishedDate
      createdAt
      updatedAt
      baseType
    }
  }
`;
export const onCreateQualityReportItems = /* GraphQL */ `
  subscription OnCreateQualityReportItems(
    $filter: ModelSubscriptionQualityReportItemsFilterInput
  ) {
    onCreateQualityReportItems(filter: $filter) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateQualityReportItems = /* GraphQL */ `
  subscription OnUpdateQualityReportItems(
    $filter: ModelSubscriptionQualityReportItemsFilterInput
  ) {
    onUpdateQualityReportItems(filter: $filter) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteQualityReportItems = /* GraphQL */ `
  subscription OnDeleteQualityReportItems(
    $filter: ModelSubscriptionQualityReportItemsFilterInput
  ) {
    onDeleteQualityReportItems(filter: $filter) {
      id
      countries
      qualityReportID
      testedItems
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCompaniesProductRequests = /* GraphQL */ `
  subscription OnCreateCompaniesProductRequests(
    $filter: ModelSubscriptionCompaniesProductRequestsFilterInput
    $id: String
    $contactPersonUserId: String
    $countryCode: String
    $involvedUsersIds: String
  ) {
    onCreateCompaniesProductRequests(
      filter: $filter
      id: $id
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
      involvedUsersIds: $involvedUsersIds
    ) {
      id
      companiesID
      productRequestsID
      companies {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      productRequests {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
    }
  }
`;
export const onUpdateCompaniesProductRequests = /* GraphQL */ `
  subscription OnUpdateCompaniesProductRequests(
    $filter: ModelSubscriptionCompaniesProductRequestsFilterInput
    $id: String
    $contactPersonUserId: String
    $countryCode: String
    $involvedUsersIds: String
  ) {
    onUpdateCompaniesProductRequests(
      filter: $filter
      id: $id
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
      involvedUsersIds: $involvedUsersIds
    ) {
      id
      companiesID
      productRequestsID
      companies {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      productRequests {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
    }
  }
`;
export const onDeleteCompaniesProductRequests = /* GraphQL */ `
  subscription OnDeleteCompaniesProductRequests(
    $filter: ModelSubscriptionCompaniesProductRequestsFilterInput
    $id: String
    $contactPersonUserId: String
    $countryCode: String
    $involvedUsersIds: String
  ) {
    onDeleteCompaniesProductRequests(
      filter: $filter
      id: $id
      contactPersonUserId: $contactPersonUserId
      countryCode: $countryCode
      involvedUsersIds: $involvedUsersIds
    ) {
      id
      companiesID
      productRequestsID
      companies {
        id
        addresses {
          additionalInformation
          company
          firstName
          lastName
          building
          city
          countryCode
          primary
          primaryBilling
          primaryShipping
          province
          room
          state
          street
          zip
        }
        contactPersonUserId
        contactPerson {
          id
          email
          imageUrl
          firstName
          lastName
          mobil
          phone
          position
          hubspotId
          countries
          type
          funnel
          createdAt
          updatedAt
        }
        companyContactPersons {
          items {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          nextToken
        }
        visits {
          items {
            id
            companyID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            visitors
            address {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            participants
            hygiene
            environment
            purpose
            visitnumber
            additionalInformation
            countryCode
            date
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        number
        externalNumber
        name
        nameSearch
        type
        googleId
        size
        itemsID
        standardPaymentConditions
        paymentConditions
        standardDeliveryConditions
        standardVat
        users {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            companyContactPersonUserId
            country
            contactPersonUserId
            email
            imageUrl
            lastLogin
            firstName
            lastName
            language
            mobil
            phone
            position
            notifications
            productTourStatus
            roleId
            role {
              id
              roleName
              type
              cognitoUserGroup
              permissions
              createdAt
              updatedAt
            }
            settings
            createdAt
            updatedAt
            countryCode
          }
          nextToken
        }
        productRequests {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        priceOffers {
          items {
            id
            createdAt
            country
            price {
              currency
              value
            }
            currency
            additionalCosts {
              costs {
                currency
                value
              }
              type
            }
            productionTime
            currentPriceOffer
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            companiesID
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            itemsID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            tiers {
              tierId
              price {
                currency
                value
              }
            }
            updatedAt
          }
          nextToken
        }
        countryCode
        closestPortUNCode
        websiteUrl
        vatNumber
        baseType
        exportCompanyId
        initialSetup
        productionCountryCode
        preferredCurrency
        communicationLanguage
        foundingDate
        companiesProductCategories {
          items {
            id
            companyId
            company {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            categoryId
            countryCode
            finalStage
            isAccepted
            createdAt
            updatedAt
          }
          nextToken
        }
        documents {
          items {
            id
            createdAt
            companyId
            companiesIDs
            collectionName
            storageKey
            type
            name
            fileType
            storageUrl
            countries
            country
            objectID
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      productRequests {
        id
        createdAt
        channel
        customerRequestsID
        customerRequests {
          id
          createdAt
          currentStatus
          shippingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          billingAddress {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          deliveryDate
          deliveryConditions
          number
          contactPersonID
          customerContactPersonID
          customerContactPerson {
            id
            companyID
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            userID
            user {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            email
            firstName
            lastName
            mobil
            phone
            position
            countryCode
            createdAt
            updatedAt
          }
          notes
          companyID
          company {
            id
            addresses {
              additionalInformation
              company
              firstName
              lastName
              building
              city
              countryCode
              primary
              primaryBilling
              primaryShipping
              province
              room
              state
              street
              zip
            }
            contactPersonUserId
            contactPerson {
              id
              email
              imageUrl
              firstName
              lastName
              mobil
              phone
              position
              hubspotId
              countries
              type
              funnel
              createdAt
              updatedAt
            }
            companyContactPersons {
              items {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              nextToken
            }
            visits {
              items {
                id
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                visitors
                address {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                documents {
                  nextToken
                }
                participants
                hygiene
                environment
                purpose
                visitnumber
                additionalInformation
                countryCode
                date
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            number
            externalNumber
            name
            nameSearch
            type
            googleId
            size
            itemsID
            standardPaymentConditions
            paymentConditions
            standardDeliveryConditions
            standardVat
            users {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              nextToken
            }
            productRequests {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            priceOffers {
              items {
                id
                createdAt
                country
                price {
                  currency
                  value
                }
                currency
                additionalCosts {
                  type
                }
                productionTime
                currentPriceOffer
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                companiesID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                itemsID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                tiers {
                  tierId
                }
                updatedAt
              }
              nextToken
            }
            countryCode
            closestPortUNCode
            websiteUrl
            vatNumber
            baseType
            exportCompanyId
            initialSetup
            productionCountryCode
            preferredCurrency
            communicationLanguage
            foundingDate
            companiesProductCategories {
              items {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                categoryId
                countryCode
                finalStage
                isAccepted
                createdAt
                updatedAt
              }
              nextToken
            }
            documents {
              items {
                id
                createdAt
                companyId
                companiesIDs
                collectionName
                storageKey
                type
                name
                fileType
                storageUrl
                countries
                country
                objectID
                updatedAt
              }
              nextToken
            }
            updatedAt
          }
          reference
          successfull
          hubspotDealId
          productRequestsID
          productRequest {
            id
            createdAt
            channel
            customerRequestsID
            customerRequests {
              id
              createdAt
              currentStatus
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              deliveryDate
              deliveryConditions
              number
              contactPersonID
              customerContactPersonID
              customerContactPerson {
                id
                companyID
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                userID
                user {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                email
                firstName
                lastName
                mobil
                phone
                position
                countryCode
                createdAt
                updatedAt
              }
              notes
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              reference
              successfull
              hubspotDealId
              productRequestsID
              productRequest {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              salesOffers {
                items {
                  id
                  customerRequestID
                  acceptedByUserID
                  createdAt
                  companyID
                  contactPersonID
                  decimalPlaces
                  number
                  productRequestsID
                  paymentConditions
                  deliveryConditions
                  deliveryTime
                  itemsSelectable
                  deliveryVat
                  declineReason
                  declineComment
                  internalComment
                  externalComment
                  customerReference
                  status
                  validUntil
                  sentExpiringReminder
                  updatedAt
                }
                nextToken
              }
              customerRequestItems {
                items {
                  id
                  createdAt
                  companyID
                  contactPersonID
                  title
                  description
                  customerArticleNumber
                  material
                  itemsID
                  notes
                  customerRequestsID
                  baseType
                  updatedAt
                }
                nextToken
              }
              messages {
                createdAt
                message
                sender
              }
              baseType
              updatedAt
            }
            priority
            involvedUsersIds
            countries
            involvedUsers {
              userId
              firstName
              lastName
              email
              country
            }
            dueDate
            currentProductRequestStatus
            positionNumber
            sentOverdueReminder
            title
            translations {
              items {
                id
                createdAt
                languageCode
                companyIDs
                field
                translation
                translationSearch
                collectionName
                objectID
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                updatedAt
              }
              nextToken
            }
            freeText
            customerCompanyID
            customerCompany {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            items {
              items {
                id
                productRequestsID
                itemsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                item {
                  id
                  companyIDs
                  companyID
                  createdAt
                  customerArticleNumber
                  title
                  description
                  number
                  ean
                  active
                  itemsHeadID
                  customsRate
                  hsCode
                  tariffCode
                  material
                  coverImageId
                  baseType
                  categoryId
                  updatedAt
                }
                selectedPriceOffersId
                priceOffer
                priceOfferMoldCosts {
                  currency
                  value
                }
                productionTime
                deliveryType
                quantity
                requestQuantity {
                  value
                  unit
                }
                minimumQuantity
                minimumOfferQuantity {
                  value
                  unit
                }
                targetPrice
                margin
                excludeAdditionalCosts
                containerSize
                airFreightCostsPerKilo
                transportCostWarehouseToCustomer
                workingCosts
                tiersId
                createdAt
                updatedAt
              }
              nextToken
            }
            companyIds {
              items {
                id
                companiesID
                productRequestsID
                companies {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                productRequests {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                createdAt
                updatedAt
                contactPersonUserId
                countryCode
                involvedUsersIds
              }
              nextToken
            }
            baseType
            updatedAt
          }
          salesOffers {
            items {
              id
              customerRequestID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              acceptedByUserID
              createdAt
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              contactPersonID
              decimalPlaces
              number
              productRequestsID
              paymentConditions
              deliveryConditions
              netSum {
                currency
                value
              }
              shippingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              deliveryTime
              billingAddress {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              offerItems {
                items {
                  id
                  salesOffersID
                  companyID
                  createdAt
                  title
                  itemsID
                  discount
                  vat
                  optional
                  editable
                  selected
                  serviceTemplate
                  updatedAt
                }
                nextToken
              }
              itemsSelectable
              deliveryCosts {
                currency
                value
              }
              deliveryVat
              declineReason
              declineComment
              internalComment
              externalComment
              customerReference
              status
              validUntil
              sentExpiringReminder
              updatedAt
            }
            nextToken
          }
          customerRequestItems {
            items {
              id
              createdAt
              companyID
              contactPersonID
              title
              description
              customerArticleNumber
              quantity {
                value
                unit
              }
              targetPrice {
                currency
                value
              }
              material
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              itemsID
              notes
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              customerRequestsID
              customerRequest {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              baseType
              updatedAt
            }
            nextToken
          }
          messages {
            createdAt
            message
            sender
          }
          baseType
          updatedAt
        }
        priority
        involvedUsersIds
        countries
        involvedUsers {
          userId
          firstName
          lastName
          email
          country
        }
        dueDate
        currentProductRequestStatus
        positionNumber
        sentOverdueReminder
        title
        translations {
          items {
            id
            createdAt
            languageCode
            companyIDs
            field
            translation
            translationSearch
            collectionName
            objectID
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            updatedAt
          }
          nextToken
        }
        freeText
        customerCompanyID
        customerCompany {
          id
          addresses {
            additionalInformation
            company
            firstName
            lastName
            building
            city
            countryCode
            primary
            primaryBilling
            primaryShipping
            province
            room
            state
            street
            zip
          }
          contactPersonUserId
          contactPerson {
            id
            email
            imageUrl
            firstName
            lastName
            mobil
            phone
            position
            hubspotId
            countries
            type
            funnel
            createdAt
            updatedAt
          }
          companyContactPersons {
            items {
              id
              companyID
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              userID
              user {
                id
                companyId
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                companyContactPersonUserId
                country
                contactPersonUserId
                email
                imageUrl
                lastLogin
                firstName
                lastName
                language
                mobil
                phone
                position
                notifications
                productTourStatus
                roleId
                role {
                  id
                  roleName
                  type
                  cognitoUserGroup
                  permissions
                  createdAt
                  updatedAt
                }
                settings
                createdAt
                updatedAt
                countryCode
              }
              email
              firstName
              lastName
              mobil
              phone
              position
              countryCode
              createdAt
              updatedAt
            }
            nextToken
          }
          visits {
            items {
              id
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              visitors
              address {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              participants
              hygiene
              environment
              purpose
              visitnumber
              additionalInformation
              countryCode
              date
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          number
          externalNumber
          name
          nameSearch
          type
          googleId
          size
          itemsID
          standardPaymentConditions
          paymentConditions
          standardDeliveryConditions
          standardVat
          users {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              companyContactPersonUserId
              country
              contactPersonUserId
              email
              imageUrl
              lastLogin
              firstName
              lastName
              language
              mobil
              phone
              position
              notifications
              productTourStatus
              roleId
              role {
                id
                roleName
                type
                cognitoUserGroup
                permissions
                createdAt
                updatedAt
              }
              settings
              createdAt
              updatedAt
              countryCode
            }
            nextToken
          }
          productRequests {
            items {
              id
              companiesID
              productRequestsID
              companies {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              productRequests {
                id
                createdAt
                channel
                customerRequestsID
                customerRequests {
                  id
                  createdAt
                  currentStatus
                  deliveryDate
                  deliveryConditions
                  number
                  contactPersonID
                  customerContactPersonID
                  notes
                  companyID
                  reference
                  successfull
                  hubspotDealId
                  productRequestsID
                  baseType
                  updatedAt
                }
                priority
                involvedUsersIds
                countries
                involvedUsers {
                  userId
                  firstName
                  lastName
                  email
                  country
                }
                dueDate
                currentProductRequestStatus
                positionNumber
                sentOverdueReminder
                title
                translations {
                  nextToken
                }
                freeText
                customerCompanyID
                customerCompany {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                items {
                  nextToken
                }
                companyIds {
                  nextToken
                }
                baseType
                updatedAt
              }
              createdAt
              updatedAt
              contactPersonUserId
              countryCode
              involvedUsersIds
            }
            nextToken
          }
          priceOffers {
            items {
              id
              createdAt
              country
              price {
                currency
                value
              }
              currency
              additionalCosts {
                costs {
                  currency
                  value
                }
                type
              }
              productionTime
              currentPriceOffer
              quantity
              requestQuantity {
                value
                unit
              }
              minimumQuantity
              minimumOfferQuantity {
                value
                unit
              }
              companiesID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              itemsID
              item {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                customerArticleNumber
                title
                description
                number
                ean
                width {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                weight {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
                active
                properties {
                  propertyId
                  name
                  values
                }
                itemsHeadID
                itemsHead {
                  id
                  companyIDs
                  companyID
                  createdAt
                  hsCode
                  tariffCode
                  material
                  customsRate
                  coverImageId
                  baseType
                  updatedAt
                }
                variant {
                  optionName
                  optionValues
                }
                customsRate
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                coverImageId
                documents {
                  nextToken
                }
                packagings {
                  type
                  quantity
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                translations {
                  nextToken
                }
                priceScreenings {
                  nextToken
                }
                baseType
                categoryId
                qualityReportTemplates {
                  nextToken
                }
                qualityReports {
                  nextToken
                }
                updatedAt
              }
              tiers {
                tierId
                price {
                  currency
                  value
                }
              }
              updatedAt
            }
            nextToken
          }
          countryCode
          closestPortUNCode
          websiteUrl
          vatNumber
          baseType
          exportCompanyId
          initialSetup
          productionCountryCode
          preferredCurrency
          communicationLanguage
          foundingDate
          companiesProductCategories {
            items {
              id
              companyId
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              categoryId
              countryCode
              finalStage
              isAccepted
              createdAt
              updatedAt
            }
            nextToken
          }
          documents {
            items {
              id
              createdAt
              companyId
              companiesIDs
              collectionName
              storageKey
              type
              name
              fileType
              storageUrl
              countries
              country
              objectID
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        items {
          items {
            id
            productRequestsID
            itemsID
            productRequest {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            item {
              id
              companyIDs
              companyID
              company {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              createdAt
              customerArticleNumber
              title
              description
              number
              ean
              width {
                value
                unit
              }
              length {
                value
                unit
              }
              height {
                value
                unit
              }
              weight {
                value
                unit
              }
              volume {
                value
                unit
              }
              active
              properties {
                propertyId
                name
                values
              }
              itemsHeadID
              itemsHead {
                id
                companyIDs
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                createdAt
                hsCode
                tariffCode
                duties {
                  id
                  goodsCode
                  goodsCodeCN
                  duty
                  createdAt
                  updatedAt
                }
                material
                customsRate
                translations {
                  nextToken
                }
                options {
                  optionName
                  optionValues
                }
                coverImageId
                priceScreenings {
                  nextToken
                }
                documents {
                  nextToken
                }
                variants {
                  nextToken
                }
                baseType
                updatedAt
              }
              variant {
                optionName
                optionValues
              }
              customsRate
              hsCode
              tariffCode
              duties {
                id
                goodsCode
                goodsCodeCN
                duty
                duties {
                  goodsCode
                  goodsCodeCN
                  addCode
                  orderNo
                  startDate
                  endDate
                  redInd
                  origin
                  measureType
                  legalBase
                  duty
                  originCode
                  measTypeCode
                }
                createdAt
                updatedAt
              }
              material
              coverImageId
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              packagings {
                type
                quantity
                weight {
                  value
                  unit
                }
                width {
                  value
                  unit
                }
                height {
                  value
                  unit
                }
                length {
                  value
                  unit
                }
                volume {
                  value
                  unit
                }
              }
              productRequests {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              priceScreenings {
                items {
                  id
                  createdAt
                  ipAddress
                  device
                  browser
                  searchTerm
                  priceCalculationMin
                  priceCalculationMax
                  itemsID
                  updatedAt
                }
                nextToken
              }
              baseType
              categoryId
              qualityReportTemplates {
                items {
                  id
                  itemsID
                  categories
                  createdAt
                  updatedAt
                }
                nextToken
              }
              qualityReports {
                items {
                  id
                  purchaseOrderItemsID
                  countries
                  maxQuantityItemsToCheck
                  itemsID
                  finalStatus
                  finishedDate
                  createdAt
                  updatedAt
                  baseType
                }
                nextToken
              }
              updatedAt
            }
            selectedPriceOffersId
            priceOffer
            priceOfferMoldCosts {
              currency
              value
            }
            productionTime
            deliveryType
            quantity
            requestQuantity {
              value
              unit
            }
            minimumQuantity
            minimumOfferQuantity {
              value
              unit
            }
            targetPrice
            margin
            excludeAdditionalCosts
            containerSize
            airFreightCostsPerKilo
            transportCostWarehouseToCustomer
            workingCosts
            tiersId
            createdAt
            updatedAt
          }
          nextToken
        }
        companyIds {
          items {
            id
            companiesID
            productRequestsID
            companies {
              id
              addresses {
                additionalInformation
                company
                firstName
                lastName
                building
                city
                countryCode
                primary
                primaryBilling
                primaryShipping
                province
                room
                state
                street
                zip
              }
              contactPersonUserId
              contactPerson {
                id
                email
                imageUrl
                firstName
                lastName
                mobil
                phone
                position
                hubspotId
                countries
                type
                funnel
                createdAt
                updatedAt
              }
              companyContactPersons {
                items {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                nextToken
              }
              visits {
                items {
                  id
                  companyID
                  visitors
                  participants
                  hygiene
                  environment
                  purpose
                  visitnumber
                  additionalInformation
                  countryCode
                  date
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              number
              externalNumber
              name
              nameSearch
              type
              googleId
              size
              itemsID
              standardPaymentConditions
              paymentConditions
              standardDeliveryConditions
              standardVat
              users {
                items {
                  id
                  companyId
                  companyContactPersonUserId
                  country
                  contactPersonUserId
                  email
                  imageUrl
                  lastLogin
                  firstName
                  lastName
                  language
                  mobil
                  phone
                  position
                  notifications
                  productTourStatus
                  roleId
                  settings
                  createdAt
                  updatedAt
                  countryCode
                }
                nextToken
              }
              productRequests {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              priceOffers {
                items {
                  id
                  createdAt
                  country
                  currency
                  productionTime
                  currentPriceOffer
                  quantity
                  minimumQuantity
                  companiesID
                  itemsID
                  updatedAt
                }
                nextToken
              }
              countryCode
              closestPortUNCode
              websiteUrl
              vatNumber
              baseType
              exportCompanyId
              initialSetup
              productionCountryCode
              preferredCurrency
              communicationLanguage
              foundingDate
              companiesProductCategories {
                items {
                  id
                  companyId
                  categoryId
                  countryCode
                  finalStage
                  isAccepted
                  createdAt
                  updatedAt
                }
                nextToken
              }
              documents {
                items {
                  id
                  createdAt
                  companyId
                  companiesIDs
                  collectionName
                  storageKey
                  type
                  name
                  fileType
                  storageUrl
                  countries
                  country
                  objectID
                  updatedAt
                }
                nextToken
              }
              updatedAt
            }
            productRequests {
              id
              createdAt
              channel
              customerRequestsID
              customerRequests {
                id
                createdAt
                currentStatus
                shippingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                billingAddress {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                deliveryDate
                deliveryConditions
                number
                contactPersonID
                customerContactPersonID
                customerContactPerson {
                  id
                  companyID
                  contactPersonUserId
                  userID
                  email
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  countryCode
                  createdAt
                  updatedAt
                }
                notes
                companyID
                company {
                  id
                  contactPersonUserId
                  createdAt
                  number
                  externalNumber
                  name
                  nameSearch
                  type
                  googleId
                  size
                  itemsID
                  standardPaymentConditions
                  paymentConditions
                  standardDeliveryConditions
                  standardVat
                  countryCode
                  closestPortUNCode
                  websiteUrl
                  vatNumber
                  baseType
                  exportCompanyId
                  initialSetup
                  productionCountryCode
                  preferredCurrency
                  communicationLanguage
                  foundingDate
                  updatedAt
                }
                reference
                successfull
                hubspotDealId
                productRequestsID
                productRequest {
                  id
                  createdAt
                  channel
                  customerRequestsID
                  priority
                  involvedUsersIds
                  countries
                  dueDate
                  currentProductRequestStatus
                  positionNumber
                  sentOverdueReminder
                  title
                  freeText
                  customerCompanyID
                  baseType
                  updatedAt
                }
                salesOffers {
                  nextToken
                }
                customerRequestItems {
                  nextToken
                }
                messages {
                  createdAt
                  message
                  sender
                }
                baseType
                updatedAt
              }
              priority
              involvedUsersIds
              countries
              involvedUsers {
                userId
                firstName
                lastName
                email
                country
              }
              dueDate
              currentProductRequestStatus
              positionNumber
              sentOverdueReminder
              title
              translations {
                items {
                  id
                  createdAt
                  languageCode
                  companyIDs
                  field
                  translation
                  translationSearch
                  collectionName
                  objectID
                  updatedAt
                }
                nextToken
              }
              freeText
              customerCompanyID
              customerCompany {
                id
                addresses {
                  additionalInformation
                  company
                  firstName
                  lastName
                  building
                  city
                  countryCode
                  primary
                  primaryBilling
                  primaryShipping
                  province
                  room
                  state
                  street
                  zip
                }
                contactPersonUserId
                contactPerson {
                  id
                  email
                  imageUrl
                  firstName
                  lastName
                  mobil
                  phone
                  position
                  hubspotId
                  countries
                  type
                  funnel
                  createdAt
                  updatedAt
                }
                companyContactPersons {
                  nextToken
                }
                visits {
                  nextToken
                }
                createdAt
                number
                externalNumber
                name
                nameSearch
                type
                googleId
                size
                itemsID
                standardPaymentConditions
                paymentConditions
                standardDeliveryConditions
                standardVat
                users {
                  nextToken
                }
                productRequests {
                  nextToken
                }
                priceOffers {
                  nextToken
                }
                countryCode
                closestPortUNCode
                websiteUrl
                vatNumber
                baseType
                exportCompanyId
                initialSetup
                productionCountryCode
                preferredCurrency
                communicationLanguage
                foundingDate
                companiesProductCategories {
                  nextToken
                }
                documents {
                  nextToken
                }
                updatedAt
              }
              items {
                items {
                  id
                  productRequestsID
                  itemsID
                  selectedPriceOffersId
                  priceOffer
                  productionTime
                  deliveryType
                  quantity
                  minimumQuantity
                  targetPrice
                  margin
                  excludeAdditionalCosts
                  containerSize
                  airFreightCostsPerKilo
                  transportCostWarehouseToCustomer
                  workingCosts
                  tiersId
                  createdAt
                  updatedAt
                }
                nextToken
              }
              companyIds {
                items {
                  id
                  companiesID
                  productRequestsID
                  createdAt
                  updatedAt
                  contactPersonUserId
                  countryCode
                  involvedUsersIds
                }
                nextToken
              }
              baseType
              updatedAt
            }
            createdAt
            updatedAt
            contactPersonUserId
            countryCode
            involvedUsersIds
          }
          nextToken
        }
        baseType
        updatedAt
      }
      createdAt
      updatedAt
      contactPersonUserId
      countryCode
      involvedUsersIds
    }
  }
`;
